import { IPF_SPAN_TYPES, IPFSpanType } from '@ikegps/core-shared';

export type TranslationFunction = (attrs) => string;
export type Translations = {
	[lang: string]: Record<T, string | TranslationFunction>;
};

export type Language = 'en-us';

export type TMessage = {
	key: string;
	attrs?: object | string;
};

export enum T {
	EMPTY = 'EMPTY',
	IKE_OFFICE = 'IKE_OFFICE',
	IKE_OFFICE_PRO = 'IKE_OFFICE_PRO',
	ACCOUNT_LOCKED = 'ACCOUNT_LOCKED',
	ACCOUNTS_TITLE = 'ACCOUNTS_TITLE',
	ACCOUNTS_NAME = 'ACCOUNTS_NAME',
	ACCOUNTS_ROLE = 'ACCOUNTS_ROLE',
	ACCOUNTS_INVITE = 'ACCOUNTS_INVITE',
	ACCOUNTS_INVITE_TITLE = 'ACCOUNTS_INVITE_TITLE',
	ACCOUNTS_INVITE_CONFIRM = 'ACCOUNTS_INVITE_CONFIRM',
	ACCOUNTS_INVITE_SUCCESS = 'ACCOUNTS_INVITE_SUCCESS',
	ACCOUNTS_INVITE_EXISTING_USER = 'ACCOUNTS_INVITE_EXISTING_USER',
	ACCOUNTS_INVITE_INVALID_USER = 'ACCOUNTS_INVITE_INVALID_USER',
	ACCOUNTS_INVITE_MAX = 'ACCOUNTS_INVITE_MAX',
	ACCOUNTS_INVITE_CHOOSE_USER_ROLE = 'ACCOUNTS_INVITE_CHOOSE_USER_ROLE',
	ACCOUNTS_REMOVE = 'ACCOUNTS_REMOVE',
	ACCOUNTS_REMOVE_TITLE = 'ACCOUNTS_REMOVE_TITLE',
	ACCOUNTS_REMOVE_CONFIRM = 'ACCOUNTS_REMOVE_CONFIRM',
	ACCOUNTS_REMOVE_SUCCESS = 'ACCOUNTS_REMOVE_SUCCESS',
	ACCOUNTS_SET_ROLE = 'ACCOUNTS_SET_ROLE',
	ACCOUNTS_SET_ROLE_TITLE = 'ACCOUNTS_SET_ROLE_TITLE',
	ACCOUNTS_SET_ROLE_CONFIRM = 'ACCOUNTS_SET_ROLE_CONFIRM',
	ACCOUNTS_SET_ROLE_SUCCESS = 'ACCOUNTS_SET_ROLE_SUCCESS',
	ANCHOR_LEAD_LENGTH_FIELD = 'ANCHOR_LEAD_LENGTH_FIELD',
	ANCHOR_OWNER_FIELD = 'ANCHOR_OWNER_FIELD',
	BANNER_MESSAGE_PT1 = 'BANNER_MESSAGE_PT1',
	BANNER_MESSAGE_PT2 = 'BANNER_MESSAGE_PT2',
	OK = 'OK',
	CANCEL = 'CANCEL',
	NEXT = 'NEXT',
	CLOSE = 'CLOSE',
	CONTINUE = 'CONTINUE',
	HERE = 'HERE',
	SEND = 'SEND',
	TRY_AGAIN = 'TRY_AGAIN',
	ACCEPT = 'ACCEPT',
	COLOR = 'COLOR',
	ALTITUDE_MISSING = 'ALTITUDE_MISSING',
	LATITUDE_MISSING = 'LATITUDE_MISSING',
	LONGITUDE_MISSING = 'LONGITUDE_MISSING',
	LOCATION_FIELD_OUT_OF_RANGE = 'LOCATION_FIELD_OUT_OF_RANGE',
	BEARING_INVALID = 'BEARING_INVALID',
	BEARING_MISSING = 'BEARING_MISSING',
	PLACEMENT_MISSING = 'PLACEMENT_MISSING',
	ACCURATE_ANCHOR_RELATED_SPAN_NO_VALUE = 'ACCURATE_ANCHOR_RELATED_SPAN_NO_VALUE',
	ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_BISECT = 'ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_BISECT',
	ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_INLINE = 'ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_INLINE',
	ACCURATE_ANCHOR_RELATED_SPAN_TITLE = 'ACCURATE_ANCHOR_RELATED_SPAN_TITLE',
	DATE_INVALID = 'DATE_INVALID',
	DEPARTMENT = 'DEPARTMENT',
	DRAWABLE_BASE_OFFSET = 'DRAWABLE_BASE_OFFSET',
	DRAWABLE_TITLE = 'DRAWABLE_TITLE',
	STATUS = 'STATUS',
	NONE = 'NONE',
	TYPE = 'TYPE',
	DASHBOARD_POLE_STATUS = 'DASHBOARD_POLE_STATUS',
	DASHBOARD_POLE_LOADING = 'DASHBOARD_POLE_LOADING',
	DASHBOARD = 'DASHBOARD',
	EMAIL_INVALID = 'EMAIL_INVALID',
	EMAIL_EXISTS_IN_DEPARTMENT = 'EMAIL_EXISTS_IN_DEPARTMENT',
	ENTER_VALID_EMAIL = 'ENTER_VALID_EMAIL',
	USER_ALREADY_EXISTS_DESCRIPTION = 'USER_ALREADY_EXISTS_DESCRIPTION',
	ERROR_GENERAL = 'ERROR_GENERAL',
	ERROR_DOWNLOAD_FAIL = 'ERROR_DOWNLOAD_FAIL',
	ERROR_EXPORT = 'ERROR_EXPORT',
	LOADING = 'LOADING',
	LOAD_MORE = 'LOAD_MORE',
	SEARCH = 'SEARCH',
	SEARCH_RES = 'SEARCH_RES',
	CLEAR_SEARCH = 'CLEAR_SEARCH',
	SEARCH_ERROR = 'SEARCH_ERROR',
	LAST_UPDATED_AT = 'LAST_UPDATED_AT',
	TAG_TITLE = 'TAG_TITLE',
	TAG_NAME = 'TAG_NAME',
	TAG_TITLE_SELECTION = 'TAG_TITLE_SELECTION',
	TAG_FILTER = 'TAG_FILTER',
	TAG_FILTER__SEARCH_EMPTY = 'TAG_FILTER__SEARCH_EMPTY',
	TAG_ZOOM = 'TAG_ZOOM',
	TAG_EXISTS = 'TAG_EXISTS',
	TAG_MERGE_TITLE = 'TAG_MERGE_TITLE',
	TAG_MERGE_CONFIRM = 'TAG_MERGE_CONFIRM',
	TAG_PHOTO = 'TAG_PHOTO',
	CLOSE_WINDOW = 'CLOSE_WINDOW',
	COLLECTION_TITLE = 'COLLECTION_TITLE',
	COLLECTION_MISSING = 'COLLECTION_MISSING',
	COLLECTION_MISSING_TITLE = 'COLLECTION_MISSING_TITLE',
	COLLECTION_COLLECTED_AT = 'COLLECTION_COLLECTED_AT',
	COLLECTION_COLLECTED_BY = 'COLLECTION_COLLECTED_BY',
	COLLECTION_UPDATED_AT = 'COLLECTION_UPDATED_AT',
	COLLECTION_UPDATED_BY = 'COLLECTION_UPDATED_BY',
	COLLECTION_ASSIGNED_TO = 'COLLECTION_ASSIGNED_TO',
	COLLECTION_FORM_NAME = 'COLLECTION_FORM_NAME',
	COLLECTION_FORM_VERSION = 'COLLECTION_FORM_VERSION',
	COLLECTION_SHOW_META = 'COLLECTION_SHOW_META',
	COLLECTION_SHOW_ZOOM = 'COLLECTION_SHOW_ZOOM',
	COLLECTION_EXPAND_ALL = 'COLLECTION_EXPAND_ALL',
	COLLECTION_COLLAPSE_ALL = 'COLLECTION_COLLAPSE_ALL',
	COLLECTION_ASSIGN = 'COLLECTION_ASSIGN',
	COLLECTION_UNASSIGNED = 'COLLECTION_UNASSIGNED',
	COLLECTION_ASSIGN_TITLE = 'COLLECTION_ASSIGN_TITLE',
	COLLECTION_ASSIGN_CONFIRM = 'COLLECTION_ASSIGN_CONFIRM',
	COLLECTION_ASSIGN_SUCCESS = 'COLLECTION_ASSIGN_SUCCESS',
	COLLECTION_MOVE = 'COLLECTION_MOVE',
	COLLECTION_MOVE_TITLE = 'COLLECTION_MOVE_TITLE',
	COLLECTION_MOVE_CONFIRM = 'COLLECTION_MOVE_CONFIRM',
	COLLECTION_MOVE_SUCCESS = 'COLLECTION_MOVE_SUCCESS',
	COLLECTION_MOVE_JOB = 'COLLECTION_MOVE_JOB',
	COLLECTION_MOVE_JOB_TITLE = 'COLLECTION_MOVE_JOB_TITLE',
	COLLECTION_MOVE_JOB_INPUT_ERROR = 'COLLECTION_MOVE_JOB_INPUT_ERROR',
	COLLECTION_MOVE_DEPARTMENT = 'COLLECTION_MOVE_DEPARTMENT',
	COLLECTION_STATUS = 'COLLECTION_STATUS',
	CLEAR_COLLECTION_STATUS = 'CLEAR_COLLECTION_STATUS',
	COLLECTION_STATUS_TITLE = 'COLLECTION_STATUS_TITLE',
	COLLECTION_STATUS_CONFIRM = 'COLLECTION_STATUS_CONFIRM',
	COLLECTION_STATUS_SUCCESS = 'COLLECTION_STATUS_SUCCESS',
	COLLECTION_STATUS_CANNOT_CHANGE = 'COLLECTION_STATUS_CANNOT_CHANGE',
	COLLECTION_MIGRATE_FORM = 'COLLECTION_MIGRATE_FORM',
	COLLECTION_MIGRATE_FORM_TITLE = 'COLLECTION_MIGRATE_FORM_TITLE',
	COLLECTION_MIGRATE_FORM_SUCCESS = 'COLLECTION_MIGRATE_FORM_SUCCESS',
	COLLECTION_MIGRATE_FORM_FAIL = 'COLLECTION_MIGRATE_FORM_FAIL',
	COLLECTION_MIGRATE_FORM_BODY_WARNING_TITLE = 'COLLECTION_MIGRATE_FORM_BODY_WARNING_TITLE',
	COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT1 = 'COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT1',
	COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT2 = 'COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT2',
	COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT3 = 'COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT3',
	COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT4 = 'COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT4',
	COLLECTION_MIGRATE_FORM_BODY = 'COLLECTION_MIGRATE_FORM_BODY',
	COLLECTION_MIGRATE_FORM_BODY_NO_FORMS = 'COLLECTION_MIGRATE_FORM_BODY_NO_FORMS',
	COLLECTION_UPDATE_FORM = 'COLLECTION_UPDATE_FORM',
	COLLECTION_UPDATE_FORM_TITLE = 'COLLECTION_UPDATE_FORM_TITLE',
	COLLECTION_UPDATE_FORM_CONFIRM = 'COLLECTION_UPDATE_FORM_CONFIRM',
	COLLECTION_UPDATE_FORM_SUCCESS = 'COLLECTION_UPDATE_FORM_SUCCESS',
	COLLECTION_UPDATE_FORM_CURRENT_REVISION = 'COLLECTION_UPDATE_FORM_CURRENT_REVISION',
	COLLECTION_UPDATE_FORM_LATEST_REVISION = 'COLLECTION_UPDATE_FORM_LATEST_REVISION',
	COLLECTION_UPDATE_FORM_ERROR = 'COLLECTION_UPDATE_FORM_ERROR',
	COLLECTION_UPDATE_HAS_LATEST_FORM = 'COLLECTION_UPDATE_HAS_LATEST_FORM',
	COLLECTION_UPDATE_FORM_ERROR_TITLE = 'COLLECTION_UPDATE_FORM_ERROR_TITLE',
	COLLECTION_UPDATE_FORM_FIELD_MISSING = 'COLLECTION_UPDATE_FORM_FIELD_MISSING',
	COLLECTION_UPDATE_FORM_FIELD_VALUE_MISSING = 'COLLECTION_UPDATE_FORM_FIELD_VALUE_MISSING',
	COLLECTION_UPDATE_FORM_FIELD_VALUE_NORMALIZE = 'COLLECTION_UPDATE_FORM_FIELD_VALUE_NORMALIZE',
	COLLECTION_UPDATE_FORM_REASON = 'COLLECTION_UPDATE_FORM_REASON',
	COLLECTION_UPDATE_FORM_FIELD_NAME = 'COLLECTION_UPDATE_FORM_FIELD_NAME',
	COLLECTION_UPDATE_FORM_VALUE = 'COLLECTION_UPDATE_FORM_VALUE',
	COLLECTION_UPDATE_FORM_WARNING_TITLE = 'COLLECTION_UPDATE_FORM_WARNING_TITLE',
	COLLECTION_UPDATE_FORM_WARNING_BODY = 'COLLECTION_UPDATE_FORM_WARNING_BODY',
	COLLECTION_UPDATE_FORM_WARNING_TABLE_TITLE = 'COLLECTION_UPDATE_FORM_WARNING_TABLE_TITLE',
	COLLECTION_UPDATE_FORM_PROCEED = 'COLLECTION_UPDATE_FORM_PROCEED',
	COLLECTION_UPDATE_FORM_CANCEL = 'COLLECTION_UPDATE_FORM_CANCEL',
	COLLECTION_REVISION_HISTORY = 'COLLECTION_REVISION_HISTORY',
	COLLECTION_REVISION_HISTORY_ID = 'COLLECTION_REVISION_HISTORY_ID',
	COLLECTION_REVISION_HISTORY_MODAL_TITLE = 'COLLECTION_REVISION_HISTORY_MODAL_TITLE',
	COLLECTION_REVISION_HISTORY_MODAL_DESCRIPTION = 'COLLECTION_REVISION_HISTORY_MODAL_DESCRIPTION',
	COLLECTION_REVISION_HISTORY_MODAL_REVERT = 'COLLECTION_REVISION_HISTORY_MODAL_REVERT',
	COLLECTION_REVISION_HISTORY_MODAL_SUCCESS = 'COLLECTION_REVISION_HISTORY_MODAL_SUCCESS',
	COLLECTION_REVISION_HISTORY_MODAL_FAILURE = 'COLLECTION_REVISION_HISTORY_MODAL_FAILURE',
	COLLECTION_REVISION_HISTORY_REVERTED_MESSAGE = 'COLLECTION_REVISION_HISTORY_REVERTED_MESSAGE',
	COLLECTION_REVISION_HISTORY_MOVED_FROM_DEPARTMENT_MESSAGE = 'COLLECTION_REVISION_HISTORY_MOVED_FROM_DEPARTMENT_MESSAGE',
	COLLECTION_REVISION_HISTORY_FORM_MIGRATED_MESSAGE = 'COLLECTION_REVISION_HISTORY_FORM_MIGRATED_MESSAGE',
	COLLECTION_REVISION_HISTORY_FORM_UPGRADED_MESSAGE = 'COLLECTION_REVISION_HISTORY_FORM_UPGRADED_MESSAGE',
	COLLECTION_REVISION_HISTORY_SPAN_LINK_MESSAGE = 'COLLECTION_REVISION_HISTORY_SPAN_LINK_MESSAGE',
	COLLECTION_INSIGHT_PROCESS = 'COLLECTION_INSIGHT_PROCESS',
	COLLECTION_INSIGHT_PROCESS_CONFIRM = 'COLLECTION_INSIGHT_PROCESS_CONFIRM',
	COLLECTION_INSIGHT_PROCESS_TITLE = 'COLLECTION_INSIGHT_PROCESS_TITLE',
	COLLECTION_INSIGHT_PROCESS_SUCCESS = 'COLLECTION_INSIGHT_PROCESS_SUCCESS',
	COLLECTION_INSIGHT_PROCESS_ERROR = 'COLLECTION_INSIGHT_PROCESS_ERROR',

	COLLECTION_DELETE = 'COLLECTION_DELETE',
	COLLECTION_DELETE_TITLE = 'COLLECTION_DELETE_TITLE',
	COLLECTION_DELETE_CONFIRM = 'COLLECTION_DELETE_CONFIRM',
	COLLECTION_DELETE_SUCCESS = 'COLLECTION_DELETE_SUCCESS',
	COLLECTION_DELETE_BTN_TITLE = 'COLLECTION_DELETE_BTN_TITLE',
	COLLECTION_DELETE_BTN_TITLE_DIRTY = 'COLLECTION_DELETE_BTN_TITLE_DIRTY',
	COLLECTION_DELETE_REJECT = 'COLLECTION_DELETE_REJECT',
	COLLECTION_EDIT = 'COLLECTION_EDIT',
	COLLECTION_EDIT_ABORT = 'COLLECTION_EDIT_ABORT',
	COLLECTION_EDIT_NO_CHANGES = 'COLLECTION_EDIT_NO_CHANGES',
	COLLECTION_EDIT_SAVE_CHANGES = 'COLLECTION_EDIT_SAVE_CHANGES',
	COLLECTION_EDIT_CREATE_SUBFORM = 'COLLECTION_EDIT_CREATE_SUBFORM',
	COLLECTION_EDIT_DELETE_SUBFORM = 'COLLECTION_EDIT_DELETE_SUBFORM',
	COLLECTION_EDIT_COPY_SUBFORM = 'COLLECTION_EDIT_COPY_SUBFORM',
	COLLECTION_EDIT_COPY_SUBFORM_MEASUREMENTS = 'COLLECTION_EDIT_COPY_SUBFORM_MEASUREMENTS',
	COLLECTION_EDIT_COPY_SUBFORM_SUCCESS = 'COLLECTION_EDIT_COPY_SUBFORM_SUCCESS',
	COLLECTION_EDIT_COPY_SUBFORM_FAILURE = 'COLLECTION_EDIT_COPY_SUBFORM_FAILURE',
	COLLECTION_EDIT_SAVE_ERROR = 'COLLECTION_EDIT_SAVE_ERROR',
	COLLECTION_IMPORT_CHOOSE_FORM = 'COLLECTION_IMPORT_CHOOSE_FORM',
	COLLECTION_IMPORT_FORM = 'COLLECTION_IMPORT_FORM',
	COLLECTION_IMPORT_CHOOSE_JOB = 'COLLECTION_IMPORT_CHOOSE_JOB',
	COLLECTION_IMPORT_CHOOSE_JOB_DESCRIPTION = 'COLLECTION_IMPORT_CHOOSE_JOB_DESCRIPTION',
	COLLECTION_IMPORT_JOB = 'COLLECTION_IMPORT_JOB',
	COLLECTION_IMPORT_MAP_FIELDS = 'COLLECTION_IMPORT_MAP_FIELDS',
	COLLECTION_IMPORT_CHOOSE_FILE_TYPE = 'COLLECTION_IMPORT_CHOOSE_FILE_TYPE',
	COLLECTION_IMPORT_EXCEL_DESCRIPTION = 'COLLECTION_IMPORT_EXCEL_DESCRIPTION',
	COLLECTION_IMPORT_EXCEL_TEMPLATE = 'COLLECTION_IMPORT_EXCEL_TEMPLATE',
	COLLECTION_IMPORT_EXCEL_USER_GUIDE = 'COLLECTION_IMPORT_EXCEL_USER_GUIDE',
	COLLECTION_IMPORT_EXCEL_USER_GUIDE_LINK = 'COLLECTION_IMPORT_EXCEL_USER_GUIDE_LINK',
	COLLECTION_IMPORT_FILE_CSV = 'COLLECTION_IMPORT_FILE_CSV',
	COLLECTION_IMPORT_FILE_EXCEL = 'COLLECTION_IMPORT_FILE_EXCEL',
	COLLECTION_IMPORT_TOO_MANY_FILES = 'COLLECTION_IMPORT_TOO_MANY_FILES',
	COLLECTION_IMPORT_NO_EXCEL_FILES = 'COLLECTION_IMPORT_NO_EXCEL_FILES',
	DROP_FILE = 'DROP_FILE',
	DRAG_FILE = 'DRAG_FILE',
	COLLECTION_IMPORT_TOO_MANY = 'COLLECTION_IMPORT_TOO_MANY',
	COLLECTION_IMPORT_FAILED = 'COLLECTION_IMPORT_FAILED',
	COLLECTION_IMPORT_SUCCESS = 'COLLECTION_IMPORT_SUCCESS',
	COLLECTION_IMPORT_GO = 'COLLECTION_IMPORT_GO',
	COLLECTION_IMPORT_CHOOSE_CSV_MAPPING = 'COLLECTION_IMPORT_CHOOSE_CSV_MAPPING',
	COLLECTION_IMPORT_TITLE = 'COLLECTION_IMPORT_TITLE',
	COLLECTION_IMPORT_NOTIFICATIONS = 'COLLECTION_IMPORT_NOTIFICATIONS',
	COLLECTION_IMPORT_FIELD_INVALID = 'COLLECTION_IMPORT_FIELD_INVALID',
	COLLECTION_IMPORT_NOT_ALLOWED = 'COLLECTION_IMPORT_NOT_ALLOWED',
	IMPORTING_COLLECTIONS = 'IMPORTING_COLLECTIONS',
	IMPORTING_MODAL_DESCRIPTION = 'IMPORTING_MODAL_DESCRIPTION',
	COLLECTION_IMPORT_PROGRESS = 'COLLECTION_IMPORT_PROGRESS',
	COLLECTION_IMPORT_RESULT_SUMMARY = 'COLLECTION_IMPORT_RESULT_SUMMARY',
	COLLECTION_IMPORT_JOB_COLLECTION_COUNT = 'COLLECTION_IMPORT_JOB_COLLECTION_COUNT',
	COLLECTION_LINK = 'COLLECTION_LINK',
	COLLECTION_LINK_START = 'COLLECTION_LINK_START',
	COLLECTION_LINK_CANCEL = 'COLLECTION_LINK_CANCEL',
	COLLECTION_LINK_INVALID = 'COLLECTION_LINK_INVALID',
	DISCARD_CHANGES_TITLE = 'DISCARD_CHANGES_TITLE',
	DISCARD_CHANGES_CONFIRM = 'DISCARD_CHANGES_CONFIRM',
	DISCARD_CHANGES_DISCARD = 'DISCARD_CHANGES_DISCARD',
	DISTANCE_MISSING = 'DISTANCE_MISSING',
	DISTANCE_VERTICAL = 'DISTANCE_VERTICAL',
	DISTANCE_HORIZONTAL = 'DISTANCE_HORIZONTAL',
	DISTANCE_VECTOR = 'DISTANCE_VECTOR',
	DISTANCE_SAG = 'DISTANCE_SAG',
	DEPARTMENT_SELECTOR_TITLE = 'DEPARTMENT_SELECTOR_TITLE',
	DEPARTMENT_SELECTOR_ACCEPT = 'DEPARTMENT_SELECTOR_ACCEPT',
	DEPARTMENT_SELECTOR_SUCCESS = 'DEPARTMENT_SELECTOR_SUCCESS',
	DEPARTMENT_SELECTOR_CURRENT = 'DEPARTMENT_SELECTOR_CURRENT',
	DEPARTMENT_SELECTOR_DISABLED = 'DEPARTMENT_SELECTOR_DISABLED',
	DEPARTMENT_SWITCH_EXPORT_IN_PROGRESS_TITLE = 'DEPARTMENT_SWITCH_EXPORT_IN_PROGRESS_TITLE',
	DEPARTMENT_SWITCH_EXPORT_IN_PROGRESS_CONFIRM = 'DEPARTMENT_SWITCH_EXPORT_IN_PROGRESS_CONFIRM',
	DEPARTMENT_SWITCH_PDF_EXPORT_IN_PROGRESS_CONFIRM = 'DEPARTMENT_SWITCH_PDF_EXPORT_IN_PROGRESS_CONFIRM',
	DEPARTMENTS_DISABLED = 'DEPARTMENTS_DISABLED',
	DISMISS = 'DISMISS',
	INPUT_REQUIRED = 'INPUT_REQUIRED',
	LINK_PHOTOMEASURE = 'LINK_PHOTOMEASURE',
	LINK_MAP_WITH_COLLECTION = 'LINK_MAP_WITH_COLLECTION',
	LINK_EDIT_TAG = 'LINK_EDIT_TAG',
	LINK_COLLECTION_LIST = 'LINK_COLLECTION_LIST',
	LINK_MAP_MODE = 'LINK_MAP_MODE',
	/* Text shown after clicking the link button on a measurement */
	PHOTOMEASURE_JOIN = 'PHOTOMEASURE_JOIN',
	PHOTOMEASURE_JOIN_START = 'PHOTOMEASURE_JOIN_START',
	PHOTOMEASURE_LINK = 'PHOTOMEASURE_LINK',
	PHOTOMEASURE_LINK_START = 'PHOTOMEASURE_LINK_START',
	PHOTOMEASURE_DELETE_ALL_TITLE = 'PHOTOMEASURE_DELETE_ALL_TITLE',
	PHOTOMEASURE_DELETE_ALL_TEXT = 'PHOTOMEASURE_DELETE_ALL_TEXT',
	PHOTOMEASURE_HIDE_IMAGE_TITLE = 'PHOTOMEASURE_HIDE_IMAGE_TITLE',
	PHOTOMEASURE_HIDE_IMAGE_TEXT = 'PHOTOMEASURE_HIDE_IMAGE_TEXT',
	PHOTOMEASURE_UNHIDE_IMAGE_TITLE = 'PHOTOMEASURE_UNHIDE_IMAGE_TITLE',
	PHOTOMEASURE_UNHIDE_IMAGE_TEXT = 'PHOTOMEASURE_UNHIDE_IMAGE_TEXT',
	VERTICAL_SEPARATION_TOP = 'VERTICAL_SEPARATION_TOP',
	VERTICAL_SEPARATION_BOTTOM = 'VERTICAL_SEPARATION_BOTTOM',
	VERTICAL_SEPARATION_INVALID = 'VERTICAL_SEPARATION_INVALID',
	BETA = 'BETA',
	LEGACY = 'LEGACY',
	EQUIPMENT_TYPE_FIELD = 'EQUIPMENT_TYPE_FIELD',
	EQUIPMENT_ORIENTATION_FIELD = 'EQUIPMENT_ORIENTATION_FIELD',
	EQUIPMENT_OWNER_FIELD = 'EQUIPMENT_OWNER_FIELD',
	EQUIPMENT_ATTACHMENT_HEIGHT_FIELD = 'EQUIPMENT_ATTACHMENT_HEIGHT_FIELD',
	EQUIPMENT_BOTTOM_HEIGHT_FIELD = 'EQUIPMENT_BOTTOM_HEIGHT_FIELD',
	EXPORT_MENU_TITLE = 'EXPORT_MENU_TITLE',
	EXPORT_MENU_TITLE_DIRTY = 'EXPORT_MENU_TITLE_DIRTY',
	EXPORT_MENU_TITLE_PERMISSION = 'EXPORT_MENU_TITLE_PERMISSION',
	EXPORT_MENU_TITLE_LIMIT = 'EXPORT_MENU_TITLE_LIMIT',
	EXPORTING_PDF_TITLE = 'EXPORTING_PDF_TITLE',
	EXPORTING_PDF_CONTENT = 'EXPORTING_PDF_CONTENT',
	EXPORT_KML = 'EXPORT_KML',
	EXCEL = 'EXCEL',
	IMPORTABLE_EXCEL = 'IMPORTABLE_EXCEL',
	CSV = 'CSV',
	EXPORT_JSON = 'EXPORT_JSON',
	EXPORT_REPORT = 'EXPORT_REPORT',
	EXPORT_REPORT_SHORT = 'EXPORT_REPORT_SHORT',
	EXPORT_REPORT_COMPOSITE_PHOTO = 'EXPORT_REPORT_COMPOSITE_PHOTO',
	EXPORT_REPORT_COMPOSITE_PHOTO_ONLY = 'EXPORT_REPORT_COMPOSITE_PHOTO_ONLY',
	EXPORT_REPORT_PHOTO = 'EXPORT_REPORT_PHOTO',
	EXPORT_SPIDA_CALC = 'EXPORT_SPIDA_CALC',
	EXPORT_SPIDA_CALC_NO_PHOTO = 'EXPORT_SPIDA_NO_PHOTO',
	EXPORT_O_CALC = 'EXPORT_O_CALC',
	EXPORT_POLEFOREMAN = 'EXPORT_POLEFOREMAN',
	EXPORT_IKE_POLEFOREMAN = 'EXPORT_IKE_POLEFOREMAN',
	EXPORT_IMAGE_ZIP = 'EXPORT_IMAGE_ZIP',
	EXPORT_DDS = 'EXPORT_DDS',
	EXPORT_SHAPEFILE = 'EXPORT_SHAPEFILE',
	EXPORT_SHAPEFILE_WGS84_TITLE = 'EXPORT_SHAPEFILE_WGS84_TITLE',
	EXPORT_SHAPEFILE_WGS84_BODY = 'EXPORT_SHAPEFILE_WGS84_BODY',
	EXPORT_NOT_EVERYTHING_EXPORTED = 'EXPORT_NOT_EVERYTHING_EXPORTED',
	EXPORT_DEPRECATED = 'EXPORT_DEPRECATED',
	EXPORT_STARTED = 'EXPORT_STARTED',
	EXPORT_MANAGER_TITLE = 'EXPORT_MANAGER_TITLE',
	EXPORT_MANAGER_EMPTY = 'EXPORT_MANAGER_EMPTY',
	EXPORT_MANAGER_CLEAR = 'EXPORT_MANAGER_CLEAR',
	EXPORT_MANAGER_CLEAR_CONFIRM = 'EXPORT_MANAGER_CLEAR_CONFIRM',
	EXPORT_MANAGER_NAVIGATE_AWAY = 'EXPORT_MANAGER_NAVIGATE_AWAY',
	EXPORT_MANAGER_NAVIGATE_TITLE = 'EXPORT_MANAGER_NAVIGATE_TITLE',
	EXPORT_MANAGER_STATUS_READY = 'EXPORT_MANAGER_STATUS_READY',
	EXPORT_MANAGER_STATUS_DOWNLOADED = 'EXPORT_MANAGER_STATUS_DOWNLOADED',
	EXPORT_MANAGER_STATUS_WARNING = 'EXPORT_MANAGER_STATUS_WARNING',
	EXPORT_MANAGER_STATUS_ERROR = 'EXPORT_MANAGER_STATUS_ERROR',
	EXPORT_MANAGER_STATUS_FAILED = 'EXPORT_MANAGER_STATUS_FAILED',
	EXPORT_FINISHED = 'EXPORT_FINISHED',
	EXPORT_FINISHED_WARNINGS = 'EXPORT_FINISHED_WARNINGS',
	EXPORT_FINISHED_ERRORS = 'EXPORT_FINISHED_ERRORS',
	FIELD_VECTOR_P2P_DISPLAY = 'FIELD_VECTOR_DISPLAY',
	FILE_TOO_LARGE = 'FILE_TOO_LARGE',
	FILE_DELETE = 'FILE_DELETE',
	FILE_DELETE_TITLE = 'FILE_DELETE_TITLE',
	FILE_DELETE_MESSAGE = 'FILE_DELETE_MESSAGE',
	FILE_NOT_SUPPORTED = 'FILE_NOT_SUPPORTED',
	FORM_TITLE = 'FORM_TITLE',
	FORM_NAME = 'FORM_NAME',
	FORM_DESCRIPTION = 'FORM_DESCRIPTION',
	FORM_VERSION = 'FORM_VERSION',
	FORM_UPDATED_AT = 'FORM_UPDATED_AT',
	FORM_CREATED_AT = 'FORM_CREATED_AT',
	FORM_EDIT = 'FORM_EDIT',
	FORM_EDIT_TITLE = 'FORM_EDIT_TITLE',
	FORM_CREATE = 'FORM_CREATE',
	FORM_IMPORT = 'FORM_IMPORT',
	FORM_IMPORT_POLEFOREMAN = 'FORM_IMPORT_POLEFOREMAN',
	FORM_IMPORT_POLEFOREMAN_ERROR_DATABASE = 'FORM_IMPORT_POLEFOREMAN_ERROR_DATABASE',
	FORM_IMPORT_POLEFOREMAN_OK = 'FORM_IMPORT_POLEFOREMAN_OK',
	FORM_IMPORT_POLEFOREMAN_FETCHING_ORGS = 'FORM_IMPORT_POLEFOREMAN_FETCHING_ORGS',
	FORM_IMPORT_POLEFOREMAN_SELECT_ORG = 'FORM_IMPORT_POLEFOREMAN_SELECT_ORG',
	FORM_IMPORT_POLEFOREMAN_FETCHING_OP_CO = 'FORM_IMPORT_POLEFOREMAN_FETCHING_OP_CO',
	FORM_IMPORT_POLEFOREMAN_ERROR_OP_CO = 'FORM_IMPORT_POLEFOREMAN_ERROR_OP_CO',
	FORM_IMPORT_POLEFOREMAN_SINGLE_OP_CO = 'FORM_IMPORT_POLEFOREMAN_SINGLE_OP_CO',
	FORM_IMPORT_POLEFOREMAN_SELECT_OP_CO = 'FORM_IMPORT_POLEFOREMAN_SELECT_OP_CO',
	FORM_IMPORT_POLEFOREMAN_DESCRIPTION = 'FORM_IMPORT_POLEFOREMAN_DESCRIPTION',
	FORM_IMPORT_POLEFOREMAN_OP_CO_DESCRIPTION = 'FORM_IMPORT_POLEFOREMAN_OP_CO_DESCRIPTION',
	FORM_IMPORT_POLEFOREMAN_NO_DATABASES = 'FORM_IMPORT_POLEFOREMAN_NO_DATABASES',
	FORM_IMPORT_POLEFOREMAN_NO_OPERATING_COMPANIES = 'FORM_IMPORT_POLEFOREMAN_NO_OPERATING_COMPANIES',
	FORM_IMPORT_POLEFOREMAN_ERROR_CREATION = 'FORM_IMPORT_POLEFOREMAN_ERROR_CREATION',
	FORM_IMPORT_UPLOAD_BUTTON = 'FORM_IMPORT_UPLOAD_BUTTON',
	FORM_IMPORT_CONFIRM = 'FORM_IMPORT_CONFIRM',
	FORM_IMPORT_SUCCEED = 'FORM_IMPORT_SUCCEED',
	FORM_IMPORT_CHOOSE_FILE = 'FORM_IMPORT_CHOOSE_FILE',
	FORM_IMPORT_VALIDATION_ERROR_TITLE = 'FORM_IMPORT_VALIDATION_ERROR_TITLE',
	FORM_IMPORT_VALIDATION_WARNING_TITLE = 'FORM_IMPORT_VALIDATION_WARNING_TITLE',
	FORM_IMPORT_VALIDATION_CREATE_FORM = 'FORM_IMPORT_VALIDATION_CREATE_FORM',
	FORM_IMPORT_VALIDATION_SECTION_ERRORS = 'FORM_IMPORT_VALIDATION_SECTION_ERRORS',
	FORM_IMPORT_VALIDATION_SECTION_WARNINGS = 'FORM_IMPORT_VALIDATION_SECTION_WARNINGS',
	FORM_IMPORT_VALIDATION_SECTION_INFO = 'FORM_IMPORT_VALIDATION_SECTION_INFO',
	FORM_NEW_POLEFOREMAN_FORM = 'FORM_NEW_POLEFOREMAN_FORM',
	FORM_NEW_COPY_CUSTOM_FIELDS_FROM = 'FORM_NEW_COPY_CUSTOM_FIELDS_FROM',
	FORM_PLA_SUPPORT = 'FORM_PLA_SUPPORT',
	FORM_LIST_ADD = 'FORM_LIST_ADD',
	FORM_FIELD_ADD_HIDE = 'FORM_FIELD_ADD_HIDE',
	FORM_FIELD_MOVE_UP = 'FORM_FIELD_MOVE_UP',
	FORM_FIELD_MOVE_DOWN = 'FORM_FIELD_MOVE_DOWN',
	FORM_FIELD_DISPLAY_NAME = 'FORM_FIELD_DISPLAY_NAME',
	FORM_FIELD_ANNOTATION_LABEL_FIELD_ID = 'FORM_FIELD_ANNOTATION_LABEL_FIELD_ID',
	FORM_FIELD_TYPE = 'FORM_FIELD_TYPE',
	FORM_FIELD_DESCRIPTION = 'FORM_FIELD_DESCRIPTION',
	FORM_OPTION_CLONEABLE = 'FORM_OPTION_CLONEABLE',
	FORM_OPTION_CLONEABLE_TITLE = 'FORM_OPTION_CLONEABLE_TITLE',
	FORM_OPTION_LABEL = 'FORM_OPTION_LABEL',
	FORM_OPTION_LABEL_TITLE = 'FORM_OPTION_LABEL_TITLE',
	FORM_OPTION_SECONDARY_LABEL = 'FORM_OPTION_SECONDARY_LABEL',
	FORM_OPTION_HIDE = 'FORM_OPTION_HIDE',
	FORM_OPTION_HIDE_TITLE = 'FORM_OPTION_HIDE_TITLE',
	FORM_OPTION_LOCKED = 'FORM_OPTION_LOCKED',
	FORM_OPTION_STATUS = 'FORM_OPTION_STATUS',
	FORM_OPTION_MAP_COLOR = 'FORM_OPTION_MAP_COLOR',
	FORM_OPTION_REQUIRED = 'FORM_OPTION_REQUIRED',
	FORM_OPTION_ADDRESS = 'FORM_OPTION_ADDRESS',
	FORM_FIELD_CHOOSE = 'FORM_FIELD_CHOOSE',
	FORM_FIELD_ADD = 'FORM_FIELD_ADD',
	FORM_FIELD_CREATE = 'FORM_FIELD_CREATE',
	FORM_FIELD_CANNOT_CHANGE = 'FORM_FIELD_CANNOT_CHANGE',
	FORM_FIELD_DELETE = 'FORM_FIELD_DELETE',
	FORM_FIELD_DELETE_TITLE = 'FORM_FIELD_DELETE_TITLE',
	FORM_FIELD_DELETE_CONFIRM = 'FORM_FIELD_DELETE_CONFIRM',
	FORM_FIELD_NESTED_LIST_DELETE = 'FORM_FIELD_NESTED_LIST_DELETE',
	FORM_FIELD_NESTED_LIST_DELETE_TITLE = 'FORM_FIELD_NESTED_LIST_DELETE_TITLE',
	FORM_FIELD_NESTED_LIST_DELETE_CONFIRM = 'FORM_FIELD_NESTED_LIST_DELETE_CONFIRM',
	FORM_DELETE = 'FORM_DELETE',
	FORM_DELETE_TITLE = 'FORM_DELETE_TITLE',
	FORM_DELETE_CONFIRM = 'FORM_DELETE_CONFIRM',
	FORM_DELETE_SUCCESS = 'FORM_DELETE_SUCCESS',
	FORM_ARCHIVE = 'FORM_ARCHIVE',
	FORM_ARCHIVE_TITLE = 'FORM_ARCHIVE_TITLE',
	FORM_ARCHIVE_CONFIRM = 'FORM_ARCHIVE_CONFIRM',
	FORM_ARCHIVE_SUCCESS = 'FORM_ARCHIVE_SUCCESS',
	FORM_RESTORE = 'FORM_RESTORE',
	FORM_RESTORE_TITLE = 'FORM_RESTORE_TITLE',
	FORM_RESTORE_CONFIRM = 'FORM_RESTORE_CONFIRM',
	FORM_RESTORE_SUCCESS = 'FORM_RESTORE_SUCCESS',
	FORM_ARCHIVED_TITLE = 'FORM_ARCHIVED_TITLE',
	FORM_DUPLICATE = 'FORM_DUPLICATE',
	FORM_COPY_TO_DEPARTMENT = 'FORM_COPY_TO_DEPARTMENT',
	FORM_SHARE = 'FORM_SHARE',
	FORM_SHARE_TITLE = 'FORM_SHARE_TITLE',
	FORM_SHARE_CONFIRM = 'FORM_SHARE_CONFIRM',
	FORM_SHARE_SUCCESS = 'FORM_SHARE_SUCCESS',
	FORM_COPY_TO_DEPARTMENT_TITLE = 'FORM_COPY_TO_DEPARTMENT_TITLE',
	FORM_COPY_TO_DEPARTMENT_CONFIRM = 'FORM_COPY_TO_DEPARTMENT_CONFIRM',
	FORM_COPY_TO_DEPARTMENT_SUCCESS = 'FORM_COPY_TO_DEPARTMENT_SUCCESS',
	FORM_COPY_TO_DEPARTMENT_DESCRIPTION = 'FORM_COPY_TO_DEPARTMENT_DESCRIPTION',
	FORM_REFRESH = 'FORM_REFRESH',
	FORM_REFRESH_MODAL_TITLE = 'FORM_REFRESH_MODAL_TITLE',
	FORM_REFRESH_MODAL_TITLE_ERROR = 'FORM_REFRESH_MODAL_TITLE_ERROR',
	FORM_REFRESH_MODAL_ERROR = 'FORM_REFRESH_MODAL_ERROR',
	FORM_REFRESH_SUCCESS = 'FORM_REFRESH_SUCCESS',
	FORM_NAME_MISSING = 'FORM_NAME_MISSING',
	FORM_DESCRIPTION_MISSING = 'FORM_DESCRIPTION_MISSING',
	FORM_ERROR_SAVING = 'FORM_ERROR_SAVING',
	FORM_ERROR_DELETING = 'FORM_ERROR_DELETING',
	FIELD_DISPLAY_NAME_MISSING = 'FIELD_DISPLAY_NAME_MISSING',
	FIELD_TEXT = 'FIELD_TEXT',
	FIELD_HEIGHT = 'FIELD_HEIGHT',
	FIELD_NUMBER = 'FIELD_NUMBER',
	FIELD_ORIENTATION = 'FIELD_ORIENTATION',
	FIELD_TRUE_SIZE = 'FIELD_TRUE_SIZE',
	FIELD_DATE = 'FIELD_DATE',
	FIELD_SELECT_LIST = 'FIELD_SELECT_LIST',
	FIELD_YES_NO = 'FIELD_YES_NO',
	FIELD_NESTED_LIST = 'FIELD_NESTED_LIST',
	FIELD_NESTED_LIST_TITLE = 'FIELD_NESTED_LIST_TITLE',
	FIELD_NESTED_LIST_VALUE = 'FIELD_NESTED_LIST_VALUE',
	FIELD_FORM = 'FIELD_FORM',
	FIELD_LOCATION = 'FIELD_LOCATION',
	FIELD_LOCATION_ACCURACY = 'FIELD_LOCATION_ACCURACY',
	FIELD_LOCATION_ALT = 'FIELD_LOCATION_ALT',
	FIELD_LOCATION_ALT_IKE = 'FIELD_LOCATION_ALT_IKE',
	FIELD_LOCATION_ALT_GROUND = 'FIELD_LOCATION_ALT_GROUND',
	FIELD_LOCATION_ANTENNA_HEIGHT = 'FIELD_LOCATION_ANTENNA_HEIGHT',
	FIELD_LOCATION_FIX = 'FIELD_LOCATION_FIX',
	FIELD_LOCATION_FIX_DGPS = 'FIELD_LOCATION_FIX_DGPS',
	FIELD_LOCATION_FIX_GPS = 'FIELD_LOCATION_FIX_GPS',
	FIELD_LOCATION_FIX_PPS = 'FIELD_LOCATION_FIX_PPS',
	FIELD_LOCATION_FIX_RTKFIXED = 'FIELD_LOCATION_FIX_RTKFIXED',
	FIELD_LOCATION_FIX_RTKFLOAT = 'FIELD_LOCATION_FIX_RTKFLOAT',
	FIELD_LOCATION_MANUAL = 'FIELD_LOCATION_MANUAL',
	FIELD_LOCATION_EDITED = 'FIELD_LOCATION_EDITED',
	FIELD_LOCATION_TRUESIZE = 'FIELD_LOCATION_TRUESIZE',
	FIELD_LOCATION_GPS = 'FIELD_LOCATION_GPS',
	FIELD_PROVIDER = 'FIELD_PROVIDER',
	FIELD_IMAGE = 'FIELD_IMAGE',
	FIELD_VECTOR = 'FIELD_VECTOR',
	FIELD_ANCHOR = 'FIELD_ANCHOR',
	FIELD_VECTOR_PROVIDER_MANUAL = 'FIELD_VECTOR_PROVIDER_MANUAL',
	FIELD_VERTICAL_SEPARATION = 'FIELD_VERTICAL_SEPARATION',
	FIELD_VERTICAL_SEPARATION_CLEARANCE = 'FIELD_VERTICAL_SEPARATION_CLEARANCE',
	FIELD_FILE_TOOL = 'FIELD_FILE_TOOL',
	FIELD_FILE_TOOL_FILE_SIZE = 'FIELD_FILE_TOOL_FILE_SIZE',
	FORM_NOT_FOUND = 'FORM_NOT_FOUND',
	SELECT_LIST_TITLE = 'SELECT_LIST_TITLE',
	SELECT_LIST_VALUE = 'SELECT_LIST_VALUE',
	SELECT_LIST_VALUE_UNIQUE = 'SELECT_LIST_VALUE_UNIQUE',

	ANCHOR_ALIGNMENT_INLINE = 'ANCHOR_ALIGNMENT_INLINE',
	ANCHOR_ALIGNMENT_BISECT = 'ANCHOR_ALIGNMENT_BISECT',
	ANCHOR_ALIGNMENT_OTHER = 'ANCHOR_ALIGNMENT_OTHER',

	LIST_MAP = 'LIST_MAP',
	LIST_JOB_LIST = 'LIST_JOB_LIST',
	LIST_FORM_LIST = 'LIST_FORM_LIST',
	LIST_USER_ACCOUNTS = 'LIST_USER_ACCOUNTS',
	LIST_COLLECTION_IMPORT = 'LIST_COLLECTION_IMPORT',

	LOGIN = 'LOGIN',
	LOGOUT = 'LOGOUT',
	LOGIN_WITH_AUTH0 = 'LOGIN_WITH_AUTH0',
	LOGIN_NO_AUTH0_ACCOUNT = 'LOGIN_NO_AUTH0_ACCOUNT',
	UNABLE_TO_START_SSO_SERVICE = 'UNABLE_TO_START_SSO_SERVICE',
	LOGIN_OFFICE = 'LOGIN_OFFICE',

	SSO_MIGRATE_EMAIL_SENT = 'SSO_MIGRATE_EMAIL_SENT',
	SSO_MIGRATE_EMAIL_EXISTING = 'SSO_MIGRATE_EMAIL_EXISTING',
	SSO_MIGRATE_FAILED = 'SSO_MIGRATE_FAILED',
	SSO_UPGRADE_ACCOUNT = 'SSO_UPGRADE_ACCOUNT',

	PASSWORD_CHANGE_PASSWORD = 'PASSWORD_CHANGE_PASSWORD',
	PASSWORD_CHANGE_PASSWORD_DETAIL = 'PASSWORD_CHANGE_PASSWORD_DETAIL',
	PASSWORD_FORGOT_TITLE = 'PASSWORD_FORGOT_TITLE',
	PASSWORD_FORGOT_EMAIL = 'PASSWORD_FORGOT_EMAIL',
	PASSWORD_FORGOT_ACCEPT = 'PASSWORD_FORGOT_ACCEPT',
	PASSWORD_RESET_EMAIL_SENT = 'PASSWORD_RESET_EMAIL_SENT',
	PASSWORD_FORGOT_SUCCESS = 'PASSWORD_FORGOT_SUCCESS',
	PLA_SPIDACALC = 'PLA_SPIDACALC',
	PLA_OCALC = 'PLA_OCALC',
	PLA_DDS = 'PLA_DDS',
	PLA_POLEFOREMAN = 'PLA_POLEFOREMAN',
	PLA_IKE_POLEFOREMAN = 'PLA_IKE_POLEFOREMAN',
	SPAN_O_MATIC = 'SPAN_O_MATIC',
	PRINT = 'PRINT',
	ME = 'ME',
	MISSING_404_CODE = 'MISSING_404_CODE',
	MISSING_404_TITLE = 'MISSING_404_TITLE',
	MISSING_404_BEFORE_LINK = 'MISSING_404_BEFORE_LINK',
	MISSING_404_LINK = 'MISSING_404_LINK',
	MISSING_404_AFTER_LINK = 'MISSING_404_AFTER_LINK',
	MISSING_403_CODE = 'MISSING_403_CODE',
	MISSING_403_TITLE = 'MISSING_403_TITLE',
	MISSING_403_BEFORE_LINK = 'MISSING_403_BEFORE_LINK',
	MISSING_403_LINK = 'MISSING_403_LINK',
	MISSING_403_AFTER_LINK = 'MISSING_403_AFTER_LINK',
	MISSING_PAGE_NA = 'MISSING_PAGE_NA',
	MULTI_ORG_MAP = 'MULTI_ORG_MAP',
	NAVIGATE_MAP = 'NAVIGATE_MAP',
	NO_LOCATION = 'NO_LOCATION',
	NO_CAPTURES = 'NO_CAPTURES',
	SELECT_CAPTURE = 'SELECT_CAPTURE',
	NOTIFICATION_IN = 'NOTIFICATION_IN',
	NOTIFICATION_ERROR_TITLE = 'NOTIFICATION_ERROR_TITLE',
	NOTIFICATION_WARNING_TITLE = 'NOTIFICATION_WARNING_TITLE',
	NOTIFICATION_CODE_REQUIRED = 'NOTIFICATION_CODE_REQUIRED',
	NOTIFICATION_CODE_DEFAULT = 'NOTIFICATION_CODE_DEFAULT',
	NOTIFICATION_CODE_INVALID = 'NOTIFICATION_CODE_INVALID',
	NOTIFICATION_CODE_UNKNOWN = 'NOTIFICATION_CODE_UNKNOWN',
	NOTIFICATION_REASON_AGL = 'NOTIFICATION_REASON_AGL',
	NOTIFICATION_REASON_NO_LOCATION = 'NOTIFICATION_REASON_NO_LOCATION',
	NOTIFICATION_REASON_NO_GUY_WIRE = 'NOTIFICATION_REASON_NO_GUY_WIRE',
	NOTIFICATION_REASON_CLIENT_ITEM = 'NOTIFICATION_REASON_CLIENT_ITEM',
	NOTIFICATION_REASON_OTHER = 'NOTIFICATION_REASON_OTHER',
	NOTIFICATION_REASON_ONLY = 'NOTIFICATION_REASON_ONLY',
	NOTIFICATION_REASON_MISSING = 'NOTIFICATION_REASON_MISSING',
	REASON_SHAPEFILE_VALUE_TRUNCATED = 'REASON_SHAPEFILE_VALUE_TRUNCATED',
	REASON_PLA_COUNT_ON_SPAN_MISMATCH = 'REASON_PLA_COUNT_ON_SPAN_MISMATCH',
	REASON_PLA_COLLECTION_LINK_ONE_WAY = 'REASON_PLA_COLLECTION_LINK_ONE_WAY',
	REASON_PLA_SPAN_SAME_TYPE_LINKED = 'REASON_PLA_SPAN_SAME_TYPE_LINKED',
	REASON_IPF_SPAN_OTHER_TO_OTHER_LINKED = 'REASON_IPF_SPAN_OTHER_TO_OTHER_LINKED',
	REASON_PLA_MULTIPLE_SPANS_LINKED = 'REASON_PLA_MULTIPLE_SPANS_LINKED',
	REASON_PLA_POWER_CIRCUIT_PHASE_HEIGHT_MISMATCH = 'REASON_PLA_POWER_CIRCUIT_PHASE_HEIGHT_MISMATCH',
	REASON_PLA_POWER_CIRCUIT_GROUP_MISMATCH = 'REASON_PLA_POWER_CIRCUIT_GROUP_MISMATCH',
	REASON_PLA_CIRCUIT_TYPE_MISMATCH = 'REASON_PLA_CIRCUIT_TYPE_MISMATCH',
	REASON_IPF_ANCHOR_ASSEMBLY_TYPE_NOT_FOUND = 'REASON_IPF_ANCHOR_ASSEMBLY_TYPE_NOT_FOUND',
	REASON_IPF_ANCHOR_LEAD_LENGTH_MISSING = 'REASON_IPF_ANCHOR_LEAD_LENGTH_MISSING',
	REASON_IPF_ANCHOR_TOO_MANY_GUYS = 'REASON_IPF_ANCHOR_TOO_MANY_GUYS',
	REASON_IPF_CONDUCTOR_TYPE_NOT_FOUND = 'REASON_IPF_CONDUCTOR_TYPE_NOT_FOUND',
	REASON_IPF_CYCLE_DETECTED = 'REASON_IPF_CYCLE_DETECTED',
	REASON_IPF_ISOLATED_POLES_DETECTED = 'REASON_IPF_ISOLATED_POLES_DETECTED',
	REASON_IPF_EQUIPMENT_ATTACHMENT_HEIGHT_MISSING = 'REASON_IPF_EQUIPMENT_ATTACHMENT_HEIGHT_MISSING',
	REASON_IPF_EQUIPMENT_ORIENTATION_MISSING = 'REASON_IPF_EQUIPMENT_ORIENTATION_MISSING',
	REASON_IPF_EQUIPMENT_TYPE_NOT_FOUND = 'REASON_IPF_EQUIPMENT_TYPE_NOT_FOUND',
	REASON_IPF_FRAMING_TYPE_NOT_FOUND = 'REASON_IPF_FRAMING_TYPE_NOT_FOUND',
	REASON_IPF_GUY_ATTACHMENT_HEIGHT_MISSING = 'REASON_IPF_GUY_ATTACHMENT_HEIGHT_MISSING',
	REASON_IPF_GUY_TYPE_NOT_FOUND = 'REASON_IPF_GUY_TYPE_NOT_FOUND',
	REASON_IPF_GUY_INSULATOR_TYPE_NOT_FOUND = 'REASON_IPF_GUY_INSULATOR_TYPE_NOT_FOUND',
	REASON_IPF_JOINT_USE_CABLE_TYPE_NOT_FOUND = 'REASON_IPF_JOINT_USE_CABLE_TYPE_NOT_FOUND',
	REASON_IPF_MULTIPLE_SPANS_SAME_TYPE = 'REASON_IPF_MULTIPLE_SPANS_SAME_TYPE',
	REASON_IPF_POWER_CIRCUIT_TYPE_NOT_FOUND = 'REASON_IPF_POWER_CIRCUIT_TYPE_NOT_FOUND',
	REASON_IPF_SERVICE_CANNOT_BE_COLLECTION_LINKED = 'REASON_IPF_SERVICE_CANNOT_BE_COLLECTION_LINKED',
	REASON_IPF_SERVICE_LENGTH_MISSING = 'REASON_IPF_SERVICE_LENGTH_MISSING',
	REASON_IPF_SERVICE_ENDPOINT_MISSING = 'REASON_IPF_SERVICE_ENDPOINT_MISSING',
	REASON_IPF_TARGET_COLLECTION_NOT_FOUND = 'REASON_IPF_TARGET_COLLECTION_NOT_FOUND',
	REASON_IPF_SERVICE_MULTIPLE_POWER_CIRCUITS = 'REASON_IPF_SERVICE_MULTIPLE_POWER_CIRCUITS',
	REASON_IPF_SERVICE_MULTIPLE_TELEPHONE_CABLES = 'REASON_IPF_SERVICE_MULTIPLE_TELEPHONE_CABLES',
	REASON_IPF_SERVICE_MULTIPLE_CATV_CABLES = 'REASON_IPF_SERVICE_MULTIPLE_CATV_CABLES',
	REASON_IPF_REQUIRED_FIELD = 'REASON_IPF_REQUIRED_FIELD',
	REASON_IPF_POWER_CIRCUIT_NEEDS_GROUP = 'REASON_IPF_POWER_CIRCUIT_NEEDS_GROUP',
	REASON_IPF_POWER_CIRCUIT_PRIMARY_PHASE_HEIGHT_MISSING = 'REASON_IPF_POWER_CIRCUIT_PRIMARY_PHASE_HEIGHT_MISSING',
	REASON_IPF_POWER_CIRCUIT_SECONDARY_PHASE_HEIGHT_MISSING = 'REASON_IPF_POWER_CIRCUIT_SECONDARY_PHASE_HEIGHT_MISSING',
	REASON_IPF_LOCATION_FALLBACK_TO_PHOTO = 'REASON_IPF_LOCATION_FALLBACK_TO_PHOTO',
	REASON_IPF_ALTITUDE_ZERO = 'REASON_IPF_ALTITUDE_ZERO',
	REASON_IPF_SECONDARY_MULTIPLEX_MORE_THAN_1_ATTACHMENT_HEIGHT = 'REASON_IPF_SECONDARY_MULTIPLEX_MORE_THAN_1_ATTACHMENT_HEIGHT',
	REASON_DDS_REQUIRED_FIELD = 'REASON_DDS_REQUIRED_FIELD',
	REASON_DDS_RECOMMENDED_FIELD = 'REASON_DDS_RECOMMENDED_FIELD',
	REASON_DDS_LOCATION_FALLBACK_TO_PHOTO = 'REASON_DDS_LOCATION_FALLBACK_TO_PHOTO',
	REASON_DDS_EQUIPMENT_TYPE_NOT_FOUND = 'REASON_DDS_EQUIPMENT_TYPE_NOT_FOUND',
	NUMBER_INVALID = 'NUMBER_INVALID',
	ORIENTATION_INVALID = 'ORIENTATION_INVALID',
	NUMBER_IMPRECISE = 'NUMBER_IMPRECISE',
	ORG_SEARCH = 'ORG_SEARCH',
	UNKNOWN = 'UNKNOWN',
	USER_MENU_FORM = 'USER_MENU_FORM',
	USER_MENU_ACCOUNTS = 'USER_MENU_ACCOUNTS',
	USER_MENU_SETTINGS = 'USER_MENU_SETTINGS',
	USER_MENU_CHANGE_PASSWORD = 'USER_MENU_CHANGE_PASSWORD',
	USER_MENU_LOGOUT = 'USER_MENU_LOGOUT',
	REPORT_PRE_LOAD_TITLE = 'REPORT_PRE_LOAD_TITLE',
	REPORT_PRE_LOAD_LOADING = 'REPORT_PRE_LOAD_LOADING',
	REPORT_PRE_LOAD_INVALID_LICENSE = 'REPORT_PRE_LOAD_INVALID_LICENSE',
	REPORT_COLLECTION_PLACE = 'REPORT_COLLECTION_PLACE',
	REPORT_COLLECTION_VECTOR = 'REPORT_COLLECTION_VECTOR',
	REPORT_COLLECTION_ANCHOR = 'REPORT_COLLECTION_ANCHOR',
	REPORT_COLLECTION_LAT_LNG = 'REPORT_COLLECTION_LAT_LNG',
	REPORT_COLLECTION_LAT_LNG_ALT = 'REPORT_COLLECTION_LAT_LNG_ALT',
	ROLE_USER = 'ROLE_USER',
	ROLE_ADMIN = 'ROLE_ADMIN',
	ROLE_EDITOR = 'ROLE_EDITOR',
	ROLE_DOWNLOADER = 'ROLE_DOWNLOADER',
	ROLE_VIEWER = 'ROLE_VIEWER',
	ROLE_DATA_ADMIN = 'ROLE_DATA_ADMIN',
	SAVE = 'SAVE',
	CLEAR_UNLOCKED_FIELDS = 'CLEAR_UNLOCKED_FIELDS',
	CLEAR_ALL_FIELDS = 'CLEAR_ALL_FIELDS',
	CLEAR_FIELDS_HELP = 'CLEAR_FIELDS_HELP',
	SELECT = 'SELECT',
	SELECT_OPTION = 'SELECT_OPTION',
	SELECT_MEASUREMENT = 'SELECT_MEASUREMENT',
	SETTINGS_TITLE = 'SETTINGS_TITLE',
	SETTINGS_DATE_FORMAT = 'SETTINGS_DATE_FORMAT',
	SETTINGS_UNITS = 'SETTINGS_UNITS',
	SETTINGS_DONE = 'SETTINGS_DONE',
	SETTINGS_SAVED = 'SETTINGS_SAVED',
	SETTINGS_ERROR_SAVING = 'SETTINGS_ERROR_SAVING',
	SIGNUP_EMAIL = 'SIGNUP_EMAIL',
	SUBMIT = 'SUBMIT',
	BACK_TO_LOGIN = 'BACK_TO_LOGIN',
	SORT_TITLE = 'SORT_TITLE',
	SORT_DESCENDING = 'SORT_DESCENDING',
	SORT_ASCENDING = 'SORT_ASCENDING',
	SORT_FIELD_COLLECTED_AT = 'SORT_FIELD_COLLECTED_AT',
	SORT_FIELD_COLLECTED_BY = 'SORT_FIELD_COLLECTED_BY',
	SORT_FIELD_UPDATED_AT = 'SORT_FIELD_UPDATED_AT',
	SORT_FIELD_NAME = 'SORT_FIELD_NAME',
	SORT_FIELD_STATUS = 'SORT_FIELD_STATUS',
	SORT_FIELD_ASSIGNED = 'SORT_FIELD_ASSIGNED',
	SPAN = 'SPAN',
	SPAN_LINK_CANCEL = 'SPAN_LINK_CANCEL',
	SPAN_LINK = 'SPAN_LINK',
	SPAN_LINK_TITLE = 'SPAN_LINK_TITLE',
	SPAN_LINK_SELECT_CONTENT = 'SPAN_LINK_SELECT_CONTENT',
	SPAN_LINK_SUCCESS = 'SPAN_LINK_SUCCESS',
	SPAN_LINK_NO_MATCH = 'SPAN_LINK_NO_MATCH',
	SPAN_LINK_VERSION_MISMATCH = 'SPAN_LINK_VERSION_MISMATCH',
	SPAN_LINK_MODAL_TITLE = 'SPAN_LINK_MODAL_TITLE',
	SPAN_LINK_WARNING_TEXT = 'SPAN_LINK_WARNING_TEXT',
	SPAN_LINK_CREATE_NEW = 'SPAN_LINK_CREATE_NEW',
	SPAN_LINK_SELECT_SPAN = 'SPAN_LINK_SELECT_SPAN',
	SPAN_LINK_SELECT_SPAN_TITLE = 'SPAN_LINK_SELECT_SPAN_TITLE',
	SPAN_LINK_LEARN_MORE = 'SPAN_LINK_LEARN_MORE',
	SPAN_LINK_NEW_SPAN_INFO = 'SPAN_LINK_NEW_SPAN_INFO',
	SPAN_LINK_CONFIRM = 'SPAN_LINK_CONFIRM',
	SPAN_LINK_DUPLICATE_ERROR = 'SPAN_LINK_DUPLICATE_ERROR',
	SPAN_LINK_TWO_WAY_SUCCESS = 'SPAN_LINK_TWO_WAY_SUCCESS',
	SPAN_LINK_ERROR = 'SPAN_LINK_ERROR',
	SPAN_LINK_TARGET_SAVE_ERROR = 'SPAN_LINK_TARGET_SAVE_ERROR',
	SPAN_UNLINK_CONFIRM_TITLE = 'SPAN_UNLINK_CONFIRM_TITLE',
	SPAN_UNLINK_CONFIRM_MESSAGE = 'SPAN_UNLINK_CONFIRM_MESSAGE',
	SPAN_UNLINK_CONFIRM_OK = 'SPAN_UNLINK_CONFIRM_OK',
	SPAN_UNLINK_BOTH_SIDES = 'SPAN_UNLINK_BOTH_SIDES',
	SPAN_VECTOR_FIELD = 'SPAN_VECTOR_FIELD',
	SPAN_TYPE_FIELD = 'SPAN_TYPE_FIELD',
	SPAN_ENVIRONMENT_FIELD = 'SPAN_ENVIRONMENT_FIELD',
	SPAN_MID_SPAN_IKE_PHOTO_FIELD = 'SPAN_MID_SPAN_IKE_PHOTO_FIELD',
	SUBFORM_REMOVE_TITLE = 'SUBFORM_REMOVE_TITLE',
	SUBFORM_REMOVE_CONFIRM = 'SUBFORM_REMOVE_CONFIRM',
	SUBFORM_REMOVE_REMOVE = 'SUBFORM_REMOVE_REMOVE',
	TOOL_BASE = 'TOOL_BASE',
	TOOL_SELECT = 'TOOL_SELECT',
	TOOL_HEIGHT = 'TOOL_HEIGHT',
	TOOL_WIDTH = 'TOOL_WIDTH',
	TOOL_ARRANGE_ANNOTATIONS = 'TOOL_ARRANGE_ANNOTATIONS',
	TOOL_CABLE_MEASURE = 'TOOL_CABLE_MEASURE',
	TOOL_CABLE_MEASURE_INCREASE = 'TOOL_CABLE_MEASURE_INCREASE',
	TOOL_CABLE_MEASURE_DECREASE = 'TOOL_CABLE_MEASURE_DECREASE',
	TOOL_ZOOM_IN = 'TOOL_ZOOM_IN',
	TOOL_ZOOM_OUT = 'TOOL_ZOOM_OUT',
	TOOL_ZOOM_RESET = 'TOOL_ZOOM_RESET',
	TOOL_BRIGHTNESS_INCREASE = 'TOOL_BRIGHTNESS_INCREASE',
	TOOL_BRIGHTNESS_DECREASE = 'TOOL_BRIGHTNESS_DECREASE',
	TOOL_BRIGHTNESS_RESET = 'TOOL_BRIGHTNESS_RESET',
	TOOL_LASER_TOGGLE = 'TOOL_LASER_TOGGLE',
	TOOL_INFO_TOGGLE = 'TOOL_INFO_TOGGLE',
	TOOL_MEASUREMENTS_CLEAR = 'TOOL_MEASUREMENTS_CLEAR',
	TOOL_DATE_TOGGLE = 'TOOL_DATE_TOGGLE',
	TOOL_BEARING_TOGGLE = 'TOOL_BEARING_TOGGLE',
	TOOL_INSIGHT_DETECTIONS_TOGGLE_MARKERS = 'TOOL_INSIGHT_DETECTIONS_TOGGLE_MARKERS',
	TOOL_INSIGHT_DETECTIONS_TOGGLE_MASKS = 'TOOL_INSIGHT_DETECTIONS_TOGGLE_MASKS',
	TOOL_INSIGHT_DETECTIONS_MARKERS_NONE = 'TOOL_INSIGHT_DETECTIONS_MARKERS_NONE',
	TOOL_INSIGHT_DETECTIONS_MASKS_NONE = 'TOOL_INSIGHT_DETECTIONS_MASKS_NONE',

	TOPO_TOOL_RELOCATE_POLE = 'TOPO_TOOL_RELOCATE_POLE',
	TOPO_TOOL_CREATE_POLE = 'TOPO_TOOL_CREATE_POLE',
	TOPO_TOOL_SNAP = 'TOPO_TOOL_SNAP',
	TOPO_TOOL_MEASURE = 'TOPO_TOOL_MEASURE',
	TOPO_SAVE_JOB = 'TOPO_SAVE_JOB',
	TOPO_SUCCESS_SAVE_JOB = 'TOPO_SUCCESS_SAVE_JOB',
	TOPO_UNSAVED_COLLECTION = 'TOPO_UNSAVED_COLLECTION',
	TOPO_SHOW_HIDE_LABELS = 'TOPO_SHOW_HIDE_LABELS',
	TOPO_SHOW_CAROUSEL = 'TOPO_SHOW_CAROUSEL',
	TOPO_SHOW_COLLECTION_DATA = 'TOPO_SHOW_COLLECTION_DATA',

	TOPO_MUST_SAVE_FIRST = 'TOPO_MUST_SAVE_FIRST',
	TOPO_MUST_SAVE_TARGET_FIRST = 'TOPO_MUST_SAVE_TARGET_FIRST',
	MEASUREMENT_CLICK_TO_REMOVE = 'MEASUREMENT_CLICK_TO_REMOVE',

	MAPMODE_LEGEND_DROPSPAN = 'MAPMODE_LEGEND_DROPSPAN',
	MAPMODE_LEGEND_ANCHOR = 'MAPMODE_LEGEND_ANCHOR',
	MAPMODE_LEGEND_SPAN = 'MAPMODE_LEGEND_SPAN',
	MAPMODE_LEGEND_UNKNOWN = 'MAPMODE_LEGEND_UNKNOWN',
	MAPMODE_LEGEND_COLLECTION_LABEL = 'MAPMODE_LEGEND_COLLECTION_LABEL',
	MAPMODE_LEGEND_SELECTED_COLLECTION = 'MAPMODE_LEGEND_SELECTED_COLLECTION',
	MAPMODE_LEGEND_LOCATION_RTK_FIXED = 'MAPMODE_LEGEND_LOCATION_RTK_FIXED',
	MAPMODE_LEGEND_LOCATION_REVIEWED = 'MAPMODE_LEGEND_LOCATION_REVIEWED',
	MAPMODE_LEGEND_LOCATION_RTK_FLOAT = 'MAPMODE_LEGEND_LOCATION_RTK_FLOAT',
	MAPMODE_LEGEND_LOCATION_LOW_ACCURACY = 'MAPMODE_LEGEND_LOCATION_LOW_ACCURACY',

	MEASUREMENT_EMPTY_STATE = 'MEASUREMENT_EMPTY_STATE',
	MEASUREMENT_PAUSE_TOOLTIP = 'MEASUREMENT_PAUSE_TOOLTIP',
	MEASUREMENT_RESUME_TOOLTIP = 'MEASUREMENT_RESUME_TOOLTIP',
	MEASUREMENT_RULING_SPAN = 'MEASUREMENT_RULING_SPAN',
	MEASUREMENT_TOTAL_DISTANCE = 'MEASUREMENT_TOTAL_DISTANCE',

	TOPO_TOOL_DISTANCE_MEASURE = 'TOPO_TOOL_DISTANCE_MEASURE',
	DISTANCE_MEASURE_DISTANCE = 'DISTANCE_MEASURE_DISTANCE',
	DISTANCE_MEASURE_BEARING = 'DISTANCE_MEASURE_BEARING',
	DISTANCE_MEASURE_EMPTY_STATE = 'DISTANCE_MEASURE_EMPTY_STATE',

	UNIT_SHORT_FEET = 'UNIT_SHORT_FEET',
	UNIT_SHORT_INCH = 'UNIT_SHORT_INCH',
	UNIT_SHORT_METER = 'UNIT_SHORT_METER',
	UNIT_SHORT_DEGREE = 'UNIT_SHORT_DEGREE',
	UNIT_METER = 'UNIT_METER',
	UNIT_FEET_INCH = 'UNIT_FEET_INCH',
	USER_ASSIGN_REQUIRED = 'USER_ASSIGN_REQUIRED',
	YES = 'YES',
	NO = 'NO',
	LAT = 'LAT',
	LNG = 'LNG',
	ERROR = 'error',
	CREATED = 'created',
	UPDATED = 'updated',
	IMPORT_FAILED = 'Import Failed',
	TOOL_CROP_SET = 'TOOL_CROP_SET',
	COLLECTION_DUPLICATE_TITLE = 'COLLECTION_DUPLICATE_TITLE',
	COLLECTION_DUPLICATE = 'COLLECTION_DUPLICATE',
	COLLECTION_DUPLICATE_CONFIRM = 'COLLECTION_DUPLICATE_CONFIRM',
	COLLECTION_DUPLICATE_SUCCESS = 'COLLECTION_DUPLICATE_SUCCESS',
	COLLECTION_DUPLICATE_NOTIFICATION_TITLE_ERRORS = 'COLLECTION_DUPLICATE_NOTIFICATION_TITLE_ERRORS',
	COLLECTION_DUPLICATE_NOTIFICATION_TITLE_WARNINGS = 'COLLECTION_DUPLICATE_NOTIFICATION_TITLE_WARNINGS',
	COLLECTION_DUPLICATE_NOTIFICATION_FAILED = 'COLLECTION_DUPLICATE_NOTIFICATION_FAILED',
	COLLECTION_DUPLICATE_NOTIFICATION_DEMOTED_NO_PARTNER = 'COLLECTION_DUPLICATE_NOTIFICATION_DEMOTED_NO_PARTNER',
	COLLECTION_DUPLICATE_NOTIFICATION_DEMOTED_PARTNER_FAILED = 'COLLECTION_DUPLICATE_NOTIFICATION_DEMOTED_PARTNER_FAILED',
	COLLECTION_DUPLICATE_NOTIFICATION_DEMOTED_NO_LOCATION = 'COLLECTION_DUPLICATE_NOTIFICATION_DEMOTED_NO_LOCATION',
	FORM_OPTION_ADMIN_ONLY = 'FORM_OPTION_ADMIN_ONLY',
	FORM_OPTION_ADMIN_ONLY_TITLE = 'FORM_OPTION_ADMIN_ONLY_TITLE',
	FORM_OPTION_STATUS_TITLE = 'FORM_OPTION_STATUS_TITLE',
	FORM_OPTION_MAP_COLOR_TITLE = 'FORM_OPTION_MAP_COLOR_TITLE',
	FORM_OPTION_REQUIRED_TITLE = 'FORM_OPTION_REQUIRED_TITLE',
	FORM_OPTION_ADDRESS_TITLE = 'FORM_OPTION_ADDRESS_TITLE',
	FORM_OPTION_PRO_ONLY_TITLE = 'FORM_OPTION_PRO_ONLY_TITLE',
	FILTER = 'FILTER',

	MESSAGE_MOBILE_VALIDATION_TITLE = 'MESSAGE_MOBILE_VALIDATION_TITLE',
	MESSAGE_MOBILE_VALIDATION_CONTENT = 'MESSAGE_MOBILE_VALIDATION_CONTENT',
	MESSAGE_BROWSER_VALIDATION_TITLE = 'MESSAGE_BROWSER_VALIDATION_TITLE',
	MESSAGE_BROWSER_VALIDATION_CONTENT = 'MESSAGE_BROWSER_VALIDATION_CONTENT',
	MESSAGE_BROWSER_VALIDATION_URL = 'MESSAGE_BROWSER_VALIDATION_URL',
	MESSAGE_BROWSER_VALIDATION_URL_TEXT = 'MESSAGE_BROWSER_VALIDATION_URL_TEXT',

	LICENSE_CHECK_FAILED_TEXT = 'LICENSE_CHECK_FAILED_TEXT',
	LICENSE_CHECK_FAILED_CONTACT_ADMIN_TEXT = 'LICENSE_CHECK_FAILED_CONTACT_ADMIN_TEXT',
	LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL = 'LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL',
	LICENSE_CHECK_FAILED_LINK = 'LICENSE_CHECK_FAILED_LINK',

	REASON_SPIDA_CALC_TITLE_INVALID = 'REASON_SPIDA_CALC_TITLE_INVALID',
	REASON_SPIDA_CALC_SPAN_LINKING_TARGET_POLE_NOT_FOUND = 'REASON_SPIDA_CALC_SPAN_LINKING_TARGET_POLE_NOT_FOUND',
	REASON_SPIDA_CALC_SPAN_LINKING_SPAN_MISMATCH = 'REASON_SPIDA_CALC_SPAN_LINKING_SPAN_MISMATCH',
	REASON_SPIDA_CALC_SPAN_LINKING_WIRES_COUNT_MISMATCH = 'REASON_SPIDA_CALC_SPAN_LINKING_WIRES_COUNT_MISMATCH',
	REASON_SPIDA_CALC_SPAN_LINKING_WIRES_TOO_MANY = 'REASON_SPIDA_CALC_SPAN_LINKING_WIRES_TOO_MANY',
	REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUYS_COUNT_MISMATCH = 'REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUYS_COUNT_MISMATCH',
	REASON_SPIDA_CALC_SPAN_LINKING_WIRE_OWNER_MISMATCH = 'REASON_SPIDA_CALC_SPAN_LINKING_WIRE_OWNER_MISMATCH',
	REASON_SPIDA_CALC_SPAN_LINKING_WIRE_USAGE_GROUP_MISMATCH = 'REASON_SPIDA_CALC_SPAN_LINKING_WIRE_USAGE_GROUP_MISMATCH',
	REASON_SPIDA_CALC_SPAN_LINKING_WIRE_SIZE_MISMATCH = 'REASON_SPIDA_CALC_SPAN_LINKING_WIRE_SIZE_MISMATCH',
	REASON_SPIDA_CALC_SPAN_LINKING_WIRE_TENSION_GROUP_MISMATCH = 'REASON_SPIDA_CALC_SPAN_LINKING_WIRE_TENSION_GROUP_MISMATCH',
	REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_OWNER_MISMATCH = 'REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_OWNER_MISMATCH',
	REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_USAGE_GROUP_MISMATCH = 'REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_USAGE_GROUP_MISMATCH',
	REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_SIZE_MISMATCH = 'REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_SIZE_MISMATCH',
	REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_TENSION_GROUP_MISMATCH = 'REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_TENSION_GROUP_MISMATCH',
	REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_ATTACHMENT_HEIGHT_EXCEED_AGL = 'REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_ATTACHMENT_HEIGHT_EXCEED_AGL',
	REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_MID_SPAN_HEIGHT_EXCEED_AGL = 'REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_MID_SPAN_HEIGHT_EXCEED_AGL',
	REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_HEIGHT_EXCEED_AGL = 'REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_HEIGHT_EXCEED_AGL',
	REASON_EXPORT_IMPORTABLE_EXCEL_MULTIPLE_FORM_VERSIONS = 'REASON_EXPORT_IMPORTABLE_EXCEL_MULTIPLE_FORM_VERSIONS',
	REASON_EXPORT_IMPORTABLE_EXCEL_TOO_MANY_COLLECTIONS = 'REASON_EXPORT_IMPORTABLE_EXCEL_TOO_MANY_COLLECTIONS',
	REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_STRING = 'REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_STRING',
	REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LATITUDE = 'REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LATITUDE',
	REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LONGITUDE = 'REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LONGITUDE',
	REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_NUMBER = 'REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_NUMBER',
	REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_BOOLEAN = 'REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_BOOLEAN',
	REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_ANCHOR = 'REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_ANCHOR',
	REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH = 'REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH',
	REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH_IMPERIAL = 'REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH_IMPERIAL',
	REASON_EXPORT_IMPORTABLE_EXCEL_FORM_ID_MISMATCH = 'REASON_EXPORT_IMPORTABLE_EXCEL_FORM_ID_MISMATCH',
	REASON_EXPORT_IMPORTABLE_EXCEL_FORM_REVISION_MISMATCH = 'REASON_EXPORT_IMPORTABLE_EXCEL_FORM_REVISION_MISMATCH',
	REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_DATE_FORMAT = 'REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_DATE_FORMAT',
	REASON_EXPORT_IMPORTABLE_EXCEL_OPTION_DOES_NOT_EXIST = 'REASON_EXPORT_IMPORTABLE_EXCEL_OPTION_DOES_NOT_EXIST',
	REASON_EXPORT_IMPORTABLE_EXCEL_USER_NOT_FOUND = 'REASON_EXPORT_IMPORTABLE_EXCEL_USER_NOT_FOUND',
	REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_OR_CORRUPTED_FILE = 'REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_OR_CORRUPTED_FILE',
	REASON_EXPORT_IMPORTABLE_EXCEL_IMPORT_FILE_NO_ROWS = 'REASON_EXPORT_IMPORTABLE_EXCEL_IMPORT_FILE_NO_ROWS',
	REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_FORM_OR_REVISION = 'REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_FORM_OR_REVISION',
	REASON_EXPORT_IMPORTABLE_EXCEL_IMPORT_EXCEPTION = 'REASON_EXPORT_IMPORTABLE_EXCEL_IMPORT_EXCEPTION',
	HELP_MENU = 'HELP_MENU',
	SUBMIT_SUPPORT_REQUEST = 'SUBMIT_SUPPORT_REQUEST',
	SUPPORT_PORTAL = 'SUPPORT_PORTAL',
	RELEASE_NOTES = 'RELEASE_NOTES',
	ALL_RELEASE_NOTES = 'ALL_RELEASE_NOTES',
	VERSION_LABEL = 'VERSION_LABEL',

	REVISION_ID = 'REVISION_ID',
	MODIFIED_AT = 'MODIFIED_AT',
	MODIFIED_BY = 'MODIFIED_BY',
	MODIFICATIONS = 'MODIFICATIONS',
}

export const CURRENT_LANG: Language = 'en-us';
export const TRANSLATIONS: Translations = {
	'en-us': {
		[T.EMPTY]: '',
		[T.IKE_OFFICE]: 'IKE Office',
		[T.IKE_OFFICE_PRO]: 'IKE Office Pro',
		[T.ACCOUNT_LOCKED]:
			'Your account has been locked due to multiple invalid login attempts. You can try again later or reset your password now.',
		[T.ACCOUNTS_TITLE]: 'Users',
		[T.ACCOUNTS_NAME]: 'Name',
		[T.ACCOUNTS_ROLE]: 'Role',
		[T.ACCOUNTS_INVITE]: 'Invite',
		[T.ACCOUNTS_INVITE_TITLE]: 'Invite New Users',
		[T.ACCOUNTS_INVITE_CONFIRM]: 'Email address to invite. Separate multiple email addresses with a comma.',
		[T.ACCOUNTS_INVITE_SUCCESS]: 'Invites Sent',
		[T.ACCOUNTS_INVITE_EXISTING_USER]: (usernames) => `Cannot invite existing users: ${usernames.join(',')}`,
		[T.ACCOUNTS_INVITE_INVALID_USER]: (usernames) => `Cannot invite invalid users: ${usernames.join(',')}`,
		[T.ACCOUNTS_INVITE_MAX]: (max) => `You can only make up to ${max} invites at one time.`,
		[T.ACCOUNTS_INVITE_CHOOSE_USER_ROLE]: 'Please choose user role',
		[T.ACCOUNTS_REMOVE]: 'Remove',
		[T.ACCOUNTS_REMOVE_TITLE]: 'Remove User',
		[T.ACCOUNTS_REMOVE_CONFIRM]: (username) => `Are you sure you would like to remove '${username}'?`,
		[T.ACCOUNTS_REMOVE_SUCCESS]: 'User Removed',
		[T.ACCOUNTS_SET_ROLE]: 'Set Role',
		[T.ACCOUNTS_SET_ROLE_TITLE]: 'Set User Role',
		[T.ACCOUNTS_SET_ROLE_CONFIRM]: ({ username, role }) => `Are you sure want to set ${username}'s role to ${role}?`,
		[T.ACCOUNTS_SET_ROLE_SUCCESS]: 'User has a new role',

		[T.ANCHOR_LEAD_LENGTH_FIELD]: 'Lead Length Field',
		[T.ANCHOR_OWNER_FIELD]: 'Owner Field',

		[T.BANNER_MESSAGE_PT1]: 'Having trouble logging in? Click ',
		[T.BANNER_MESSAGE_PT2]: ' for instructions on the new IKE ID',

		[T.OK]: 'Ok',
		[T.CANCEL]: 'Cancel',
		[T.NEXT]: 'Next',
		[T.CLOSE]: 'Close',
		[T.CONTINUE]: 'Continue',
		[T.HERE]: 'HERE',
		[T.SEND]: 'Send',
		[T.TRY_AGAIN]: 'Try again',
		[T.ACCEPT]: 'Accept',
		[T.COLOR]: 'Color',

		[T.ALTITUDE_MISSING]: 'Altitude missing',
		[T.LATITUDE_MISSING]: 'Latitude missing',
		[T.LONGITUDE_MISSING]: 'Longitude missing',
		[T.BEARING_INVALID]: 'Invalid bearing',
		[T.BEARING_MISSING]: 'Missing bearing',
		[T.PLACEMENT_MISSING]: 'Missing placement',
		[T.ACCURATE_ANCHOR_RELATED_SPAN_NO_VALUE]: 'The selected span(s) do not have a bearing specified',
		[T.ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_BISECT]: 'A bisect placement requires both spans to be selected',
		[T.ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_INLINE]: 'An inline placement requires a span to be select',
		[T.LOCATION_FIELD_OUT_OF_RANGE]: ({ field, maxValue }) => `${field} between -${maxValue} and ${maxValue} required`,

		[T.DATE_INVALID]: 'Invalid date',

		[T.DEPARTMENT]: 'Department',

		[T.EMAIL_INVALID]: 'Invalid Email',
		[T.EMAIL_EXISTS_IN_DEPARTMENT]: 'You are already logged in as a member.',
		[T.ENTER_VALID_EMAIL]: 'Please enter a valid email address',
		[T.USER_ALREADY_EXISTS_DESCRIPTION]: 'A user with this email address already exists. Try logging in.',

		[T.ERROR_GENERAL]: 'An error occurred',
		[T.ERROR_EXPORT]: 'There was an error exporting your collections',
		[T.ERROR_DOWNLOAD_FAIL]: 'Could not download file. Contact support.',

		[T.LOADING]: 'Loading...',
		[T.LOAD_MORE]: 'Load more',

		[T.LINK_PHOTOMEASURE]: 'PhotoMeasure collections',
		[T.LINK_COLLECTION_LIST]: 'Edit Collection List',
		[T.LINK_MAP_MODE]: 'Edit job in Map Based Review Mode',
		[T.LINK_EDIT_TAG]: 'Edit job name',
		[T.LINK_MAP_WITH_COLLECTION]: 'View collection details in the Big Map',

		[T.DRAWABLE_BASE_OFFSET]: 'Base offset',
		[T.DRAWABLE_TITLE]: 'Title',

		[T.STATUS]: 'Status',
		[T.NONE]: 'None',
		[T.TYPE]: 'Type',
		[T.DASHBOARD_POLE_LOADING]: 'Pole Loading',
		[T.DASHBOARD_POLE_STATUS]: 'Pole Status',
		[T.DASHBOARD]: 'Dashboard',

		[T.COLLECTION_TITLE]: 'Collections',

		[T.CLOSE_WINDOW]: 'Close Window',

		[T.COLLECTION_MISSING]: 'Collection not found',
		[T.COLLECTION_MISSING_TITLE]: 'No title',
		[T.COLLECTION_COLLECTED_AT]: 'Collected at',
		[T.COLLECTION_COLLECTED_BY]: 'Collected by',
		[T.COLLECTION_UPDATED_AT]: 'Last modified',
		[T.COLLECTION_UPDATED_BY]: 'Last modified by',
		[T.COLLECTION_ASSIGNED_TO]: 'Assigned to',
		[T.COLLECTION_FORM_NAME]: 'Form',
		[T.COLLECTION_FORM_VERSION]: 'Form version',
		[T.COLLECTION_EXPAND_ALL]: 'Expand all',
		[T.COLLECTION_COLLAPSE_ALL]: 'Collapse all',
		[T.COLLECTION_ASSIGN]: 'Assign',
		[T.COLLECTION_UNASSIGNED]: 'Unassigned',
		[T.COLLECTION_ASSIGN_TITLE]: 'Assign Collections',
		[T.COLLECTION_ASSIGN_CONFIRM]: ({ count }) => `Assign ${count} ${count === 1 ? 'collection' : 'collections'} to:`,
		[T.COLLECTION_ASSIGN_SUCCESS]: ({ count }) => `${count} ${count === 1 ? 'collection' : 'collections'} re-assigned`,
		[T.COLLECTION_MOVE]: 'Move',
		[T.COLLECTION_MOVE_TITLE]: 'Move Collections',
		[T.COLLECTION_MOVE_CONFIRM]: ({ count }) => `Move ${count} ${count === 1 ? 'collection' : 'collections'} to:`,
		[T.COLLECTION_MOVE_SUCCESS]: ({ count }) => `${count} ${count === 1 ? 'collection' : 'collections'} moved`,
		[T.COLLECTION_MOVE_JOB]: 'Move to Job',
		[T.COLLECTION_MOVE_JOB_TITLE]: 'Move Collections to Job',
		[T.COLLECTION_MOVE_JOB_INPUT_ERROR]: 'You need a Job name to move Collections to',
		[T.COLLECTION_MOVE_DEPARTMENT]: 'Move to Department',
		[T.COLLECTION_DUPLICATE]: 'Duplicate',
		[T.COLLECTION_DUPLICATE_TITLE]: 'Duplicate Collections',
		[T.COLLECTION_DUPLICATE_CONFIRM]: ({ count }) =>
			`Are you sure you would like to duplicate ${count} ${count === 1 ? 'collection' : 'collections'}?`,
		[T.COLLECTION_DUPLICATE_SUCCESS]: ({ count }) =>
			`${count} ${count === 1 ? 'collection' : 'collections'} duplicated`,
		[T.COLLECTION_DUPLICATE_NOTIFICATION_TITLE_ERRORS]: 'Duplicate completed with errors',
		[T.COLLECTION_DUPLICATE_NOTIFICATION_TITLE_WARNINGS]: 'Duplicate completed with warnings',
		[T.COLLECTION_DUPLICATE_NOTIFICATION_FAILED]: 'Failed to duplicate',
		[T.COLLECTION_DUPLICATE_NOTIFICATION_DEMOTED_NO_PARTNER]:
			'Span link replaced with a manual measurement — the linked pole was not duplicated',
		[T.COLLECTION_DUPLICATE_NOTIFICATION_DEMOTED_PARTNER_FAILED]:
			'Span link replaced with a manual measurement — the linked pole failed to duplicate',
		[T.COLLECTION_DUPLICATE_NOTIFICATION_DEMOTED_NO_LOCATION]:
			'Span link removed — no measurement snapshot was available',
		[T.COLLECTION_STATUS]: 'Set Status',
		[T.CLEAR_COLLECTION_STATUS]: 'Clear Status',
		[T.COLLECTION_STATUS_TITLE]: 'Set Collection Status',
		[T.COLLECTION_STATUS_CONFIRM]: ({ count }) =>
			`Set status for ${count} ${count === 1 ? 'collection' : 'collections'} to:`,
		[T.COLLECTION_STATUS_SUCCESS]: ({ count }) =>
			`${count} ${count === 1 ? 'collection' : 'collections'} got new status`,
		[T.COLLECTION_STATUS_CANNOT_CHANGE]: ({ count }) => `Can't change: ${count}`,
		[T.COLLECTION_MIGRATE_FORM]: 'Migrate Form',
		[T.COLLECTION_MIGRATE_FORM_TITLE]: 'Form migration',
		[T.COLLECTION_MIGRATE_FORM_SUCCESS]: 'Successfully migrated collection forms',
		[T.COLLECTION_MIGRATE_FORM_FAIL]: 'Failed to migrate. Please try again later',
		[T.COLLECTION_MIGRATE_FORM_BODY_WARNING_TITLE]: 'WARNING: Data may be lost during Form migration',
		[T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT1]:
			"When migrating Forms, any data that doesn't have a matching field or matching value option in the target Form will be deleted.",
		[T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT2]: 'To prevent data loss:',
		[T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT3]:
			'Consider duplicating your poles first to preserve all information, and only migrate one set of them.',
		[T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT4]:
			"If needed, you can restore data using each pole's revision history, but note this can be time-consuming.",
		[T.COLLECTION_MIGRATE_FORM_BODY]: 'Choose a form to migrate the selected collections to:',
		[T.COLLECTION_MIGRATE_FORM_BODY_NO_FORMS]: 'No forms available for migration',
		[T.COLLECTION_UPDATE_FORM]: 'Update Form',
		[T.COLLECTION_UPDATE_FORM_TITLE]: 'Update Collection Form',
		[T.COLLECTION_UPDATE_FORM_CONFIRM]: ({ count }) =>
			`Update form for ${count} ${count === 1 ? 'collection' : 'collections'}`,
		[T.COLLECTION_UPDATE_FORM_ERROR_TITLE]: ({ count }) =>
			`Can't update the collections because of ${count} ${count === 1 ? 'error' : 'errors'}`,
		[T.COLLECTION_UPDATE_FORM_FIELD_MISSING]: 'Field is missing in new form',
		[T.COLLECTION_UPDATE_FORM_FIELD_VALUE_MISSING]: 'Field value is missing in new form',
		[T.COLLECTION_UPDATE_FORM_FIELD_VALUE_NORMALIZE]: 'Value outside 0-360°',
		[T.COLLECTION_UPDATE_FORM_REASON]: 'Reason',
		[T.COLLECTION_UPDATE_FORM_VALUE]: 'Value',
		[T.COLLECTION_UPDATE_FORM_FIELD_NAME]: 'Field Name',
		[T.COLLECTION_UPDATE_FORM_SUCCESS]: 'Successfully updated forms.',
		[T.COLLECTION_UPDATE_FORM_CURRENT_REVISION]: 'Current Form Revision',
		[T.COLLECTION_UPDATE_FORM_LATEST_REVISION]: 'Latest Form Revision',
		[T.COLLECTION_UPDATE_FORM_ERROR]: 'Form update error',
		[T.COLLECTION_UPDATE_HAS_LATEST_FORM]: 'Latest form',
		[T.COLLECTION_UPDATE_FORM_WARNING_TITLE]: 'Warning: This form update will delete data.',
		[T.COLLECTION_UPDATE_FORM_WARNING_BODY]:
			"When updating Forms, any data that doesn't have a matching field or matching value option in the target Form will be deleted.",
		[T.COLLECTION_UPDATE_FORM_WARNING_TABLE_TITLE]: ({ count }) =>
			`${count} ${count === 1 ? 'collection' : 'collections'} will lose data if you proceed`,
		[T.COLLECTION_UPDATE_FORM_PROCEED]: 'Update Form',
		[T.COLLECTION_UPDATE_FORM_CANCEL]: 'Cancel Update',
		[T.COLLECTION_REVISION_HISTORY]: 'Revision History',
		[T.COLLECTION_REVISION_HISTORY_ID]: (collectionName) => `Revision History: ${collectionName}`,
		[T.COLLECTION_REVISION_HISTORY_MODAL_TITLE]: ({ collectionName, revisionId }) =>
			`Revert Collection ${collectionName} to revision ${revisionId}`,
		[T.COLLECTION_REVISION_HISTORY_MODAL_DESCRIPTION]: 'Are you sure you want to revert this collection?',
		[T.COLLECTION_REVISION_HISTORY_MODAL_REVERT]: 'Revert',
		[T.COLLECTION_REVISION_HISTORY_MODAL_SUCCESS]: 'Collection successfully reverted',
		[T.COLLECTION_REVISION_HISTORY_MODAL_FAILURE]: 'Collection revert failed',
		[T.COLLECTION_REVISION_HISTORY_REVERTED_MESSAGE]: (departmentName) => `Reverted to revision ${departmentName}`,
		[T.COLLECTION_REVISION_HISTORY_MOVED_FROM_DEPARTMENT_MESSAGE]: (collectionRevisionId) =>
			`Moved from ${collectionRevisionId}`,
		[T.COLLECTION_REVISION_HISTORY_FORM_MIGRATED_MESSAGE]: ({ from, to }) => `Form migrated from ${from} to ${to}`,
		[T.COLLECTION_REVISION_HISTORY_FORM_UPGRADED_MESSAGE]: ({
			title,
			from,
			to,
		}: {
			title: string;
			from: number;
			to: number;
		}) => `Form updated from "${title}" V${from} to V${to}`,
		[T.COLLECTION_REVISION_HISTORY_SPAN_LINK_MESSAGE]: ({ poleTitle }) => `Span linked to "${poleTitle}"`,
		[T.COLLECTION_INSIGHT_PROCESS]: 'Run PolePilot',
		[T.COLLECTION_INSIGHT_PROCESS_TITLE]: 'Run PolePilot Processing',
		[T.COLLECTION_INSIGHT_PROCESS_CONFIRM]: (count) =>
			`Please confirm that you would like to request PolePilot detections processing for the ${count} selected collection(s).\n
            If the department is correctly configured for processing PolePilot detections, these collections will be added to a queue for processing.\n
            Generally, detections should be available within 12 hours.`,
		[T.COLLECTION_INSIGHT_PROCESS_SUCCESS]: 'PolePilot processing requests sent!',
		[T.COLLECTION_INSIGHT_PROCESS_ERROR]: 'An error occurred while processing collections with PolePilot: ',
		[T.COLLECTION_DELETE]: 'Delete',
		[T.COLLECTION_DELETE_TITLE]: 'Delete Collections',
		[T.COLLECTION_DELETE_CONFIRM]: (count) =>
			`Are you sure you would like to delete ${count} ${count === 1 ? 'collection' : 'collections'}?`,
		[T.COLLECTION_DELETE_SUCCESS]: ({ count }) => `${count} ${count === 1 ? 'collection' : 'collections'} deleted`,
		[T.COLLECTION_DELETE_BTN_TITLE]: 'Delete selected collections',
		[T.COLLECTION_DELETE_BTN_TITLE_DIRTY]: 'Please save your changes before deleting.',
		[T.COLLECTION_DELETE_REJECT]: ({ max }) => `Cannot delete more than ${max} jobs at once`,
		[T.COLLECTION_SHOW_META]: 'Show collection information',
		[T.COLLECTION_SHOW_ZOOM]: 'Show attachment preview',
		[T.IMPORTING_COLLECTIONS]: 'Importing collections...',
		[T.IMPORTING_MODAL_DESCRIPTION]: 'This could take several minutes. Do not refresh the page.',
		[T.COLLECTION_IMPORT_PROGRESS]: ({ count, total }) => `Importing ${count} of ${total}...`,

		[T.COLLECTION_LINK]: 'Collection Link',
		[T.COLLECTION_LINK_START]: 'Select a collection on the map to link to',
		[T.COLLECTION_LINK_CANCEL]: 'Cancel Collection Link',
		[T.COLLECTION_LINK_INVALID]: 'Cannot link to same collection',

		[T.COLLECTION_EDIT]: 'Edit collection',
		[T.COLLECTION_EDIT_ABORT]: 'Discard changes',
		[T.COLLECTION_EDIT_NO_CHANGES]: 'No changes',
		[T.COLLECTION_EDIT_SAVE_CHANGES]: 'Save changes',
		[T.COLLECTION_EDIT_CREATE_SUBFORM]: ({ title }) => `Add new ${title}`,
		[T.COLLECTION_EDIT_DELETE_SUBFORM]: ({ title }) => `Remove ${title}`,
		[T.COLLECTION_EDIT_COPY_SUBFORM]: ({ title }) => `Duplicate ${title}`,
		[T.COLLECTION_EDIT_COPY_SUBFORM_MEASUREMENTS]: ({ title }) => `Duplicate ${title} with measurements`,
		[T.COLLECTION_EDIT_COPY_SUBFORM_SUCCESS]: ({ title }) => `Copied ${title}`,
		[T.COLLECTION_EDIT_COPY_SUBFORM_FAILURE]: ({ title }) => `${title} failed to copy`,
		[T.COLLECTION_EDIT_SAVE_ERROR]: 'Failed to save collection',

		[T.COLLECTION_IMPORT_CHOOSE_FORM]: 'Choose a form template to download',
		[T.COLLECTION_IMPORT_FORM]: 'Form',
		[T.COLLECTION_IMPORT_CHOOSE_JOB]: 'Choose a job to import into',
		[T.COLLECTION_IMPORT_CHOOSE_JOB_DESCRIPTION]: 'Enter a new job name or choose from existing',
		[T.COLLECTION_IMPORT_JOB]: 'Job',
		[T.COLLECTION_IMPORT_MAP_FIELDS]: 'Map your CSV fields into your form',
		[T.COLLECTION_IMPORT_CHOOSE_FILE_TYPE]: (fileType) => `Choose ${fileType} file to import from`,
		[T.COLLECTION_IMPORT_EXCEL_DESCRIPTION]: 'Upload a single file or a zip containing multiple EXCEL files',
		[T.COLLECTION_IMPORT_EXCEL_TEMPLATE]: 'Download the template for importing with your chosen form',
		[T.COLLECTION_IMPORT_EXCEL_USER_GUIDE]: 'Learn more in our user guide on how to import your data',
		[T.COLLECTION_IMPORT_EXCEL_USER_GUIDE_LINK]:
			'https://support.ikegps.com/hc/en-us/articles/28311181980557-IKE-Office-Pro-Bulk-Import-User-Guide',
		[T.COLLECTION_IMPORT_FILE_CSV]: 'CSV File',
		[T.COLLECTION_IMPORT_FILE_EXCEL]: 'Excel File',
		[T.DROP_FILE]: 'Drop file here',
		[T.DRAG_FILE]: 'Drag file here or click to upload',
		[T.COLLECTION_IMPORT_TOO_MANY]: ({ count, max }) => `Cannot import more than ${max} collections.`,
		[T.COLLECTION_IMPORT_TOO_MANY_FILES]: ({ max }) => `Cannot import more than ${max} files.`,
		[T.COLLECTION_IMPORT_NO_EXCEL_FILES]: 'No excel files found in zip',
		[T.COLLECTION_IMPORT_FAILED]: ({ reason }) => `Failed to import collections. ${reason}`,
		[T.COLLECTION_IMPORT_GO]: 'Import',
		[T.COLLECTION_IMPORT_CHOOSE_CSV_MAPPING]: 'Select CSV field',
		[T.COLLECTION_IMPORT_TITLE]: 'Import Collections',
		[T.COLLECTION_IMPORT_NOTIFICATIONS]: 'Import Notifications',
		[T.COLLECTION_IMPORT_SUCCESS]: ({ count }) => `${count} ${count === 1 ? 'collection' : 'collections'} imported!`,
		[T.COLLECTION_IMPORT_FIELD_INVALID]: ({ field }) => `Field cannot be imported into ${field}`,
		[T.COLLECTION_IMPORT_NOT_ALLOWED]: 'You do not have the correct permissions to import collections.',
		[T.COLLECTION_IMPORT_RESULT_SUMMARY]: ({
			successful,
			failed,
			skipped,
		}: {
			successful: number;
			failed: number;
			skipped: number;
		}) =>
			[
				`${successful} ${successful === 1 ? 'job' : 'jobs'} successful`,
				`${failed} ${failed === 1 ? 'job' : 'jobs'} with failures`,
				`${skipped} ${skipped === 1 ? 'file' : 'files'} skiped`,
			].join(', '),
		[T.COLLECTION_IMPORT_JOB_COLLECTION_COUNT]: ({ successful, failed }: { successful: number; failed: number }) =>
			// it is possible that we get 0 collections successful and 0 collections failed when the form is invalid or there are no collection rows, so we don't show number failed
			`${successful} ${successful === 1 ? 'collection' : 'collections'} successful${successful + failed > 0 ? `, ${failed} ${failed === 1 ? 'collection' : 'collections'} failed` : ''}`,
		[T.DISCARD_CHANGES_TITLE]: 'Discard changes',
		[T.DISCARD_CHANGES_CONFIRM]: 'Are you sure you want to discard unsaved changes?',
		[T.DISCARD_CHANGES_DISCARD]: 'Discard',

		[T.DISTANCE_MISSING]: 'Missing distance',
		[T.DISTANCE_HORIZONTAL]: 'Horizontal distance',
		[T.DISTANCE_VERTICAL]: 'Vertical distance',
		[T.DISTANCE_VECTOR]: 'Vector',
		[T.DISTANCE_SAG]: 'Sag',

		[T.DEPARTMENT_SELECTOR_TITLE]: 'Change Department',
		[T.DEPARTMENT_SELECTOR_ACCEPT]: 'Change',
		[T.DEPARTMENT_SELECTOR_SUCCESS]: 'Department changed',
		[T.DEPARTMENT_SELECTOR_CURRENT]: 'Current',
		[T.DEPARTMENT_SELECTOR_DISABLED]: 'Disabled',
		[T.DEPARTMENT_SWITCH_EXPORT_IN_PROGRESS_TITLE]: 'Change department?',
		[T.DEPARTMENT_SWITCH_PDF_EXPORT_IN_PROGRESS_CONFIRM]:
			'You cannot change departments while there is an active IKE Report in progress.',
		[T.DEPARTMENT_SWITCH_EXPORT_IN_PROGRESS_CONFIRM]:
			'Are you sure you want to change department? You currently have an export in progress.',
		[T.DEPARTMENTS_DISABLED]: 'Departments are disabled.',

		[T.DISMISS]: 'Dismiss',

		[T.INPUT_REQUIRED]: 'Value required',

		[T.LAST_UPDATED_AT]: ({ timeString }) => `Last modified at ${timeString}`,
		[T.SEARCH]: 'Search jobs and collections',
		[T.SEARCH_RES]: 'Search Results',
		[T.CLEAR_SEARCH]: 'Clear search',
		[T.SEARCH_ERROR]: 'Search query is too long',
		[T.TAG_TITLE]: 'Jobs',
		[T.TAG_NAME]: 'Job Name',
		[T.TAG_FILTER]: 'Filter Jobs',
		[T.TAG_FILTER__SEARCH_EMPTY]: 'No results found',
		[T.TAG_ZOOM]: 'Zoom to jobs',
		[T.TAG_EXISTS]: (name) => `'${name}' already exists.`,
		[T.TAG_MERGE_TITLE]: 'Rename job',
		[T.TAG_MERGE_CONFIRM]: ({ collectionCount, oldName, newName }) =>
			`Are you sure you want to merge ${collectionCount} ${
				collectionCount > 1 ? 'collections' : 'collection'
			} from '${oldName}' into '${newName}'?`,
		[T.TAG_TITLE_SELECTION]: (count) => `${count} collection${count !== 1 ? 's' : ''} selected`,
		[T.TAG_PHOTO]: (plural) => `Tag Photo${plural ? 's' : ''}`,

		[T.BETA]: 'beta',
		[T.LEGACY]: 'legacy',

		[T.EQUIPMENT_TYPE_FIELD]: 'Type Field',
		[T.EQUIPMENT_ORIENTATION_FIELD]: 'Orientation Field',
		[T.EQUIPMENT_OWNER_FIELD]: 'Owner Field',
		[T.EQUIPMENT_ATTACHMENT_HEIGHT_FIELD]: 'Attachment Height Field',
		[T.EQUIPMENT_BOTTOM_HEIGHT_FIELD]: 'Bottom Height Field',

		[T.EXPORT_MENU_TITLE]: 'Export selected collections',
		[T.EXPORT_MENU_TITLE_DIRTY]: 'Please save your changes before exporting.',
		[T.EXPORT_MENU_TITLE_PERMISSION]: "You don't have the appropriate permissions.",
		[T.EXPORT_MENU_TITLE_LIMIT]: ({ limit }) => `Too many collections selected (max ${limit})`,
		[T.EXPORTING_PDF_TITLE]: 'Generating PDF export',
		[T.EXPORTING_PDF_CONTENT]: 'PDF export generation in progress...',
		[T.EXPORT_KML]: 'KML',
		[T.EXCEL]: 'EXCEL',
		[T.IMPORTABLE_EXCEL]: 'IMPORTABLE EXCEL',
		[T.CSV]: 'CSV',
		[T.EXPORT_JSON]: 'JSON',
		[T.EXPORT_REPORT]: 'IKE REPORT',
		[T.EXPORT_REPORT_SHORT]: 'IKE REPORT SHORT',
		[T.EXPORT_REPORT_COMPOSITE_PHOTO]: 'COMPOSITE PHOTO REPORT',
		[T.EXPORT_REPORT_COMPOSITE_PHOTO_ONLY]: 'ONLY COMPOSITE PHOTO REPORT',
		[T.EXPORT_REPORT_PHOTO]: 'PHOTO REPORT',
		[T.EXPORT_SPIDA_CALC]: 'SPIDACALC WITH PHOTOS',
		[T.EXPORT_SPIDA_CALC_NO_PHOTO]: 'SPIDACALC NO PHOTOS',
		[T.EXPORT_O_CALC]: 'OCALC',
		[T.EXPORT_POLEFOREMAN]: 'POLEFOREMAN',
		[T.EXPORT_IKE_POLEFOREMAN]: 'IKE POLEFOREMAN',
		[T.EXPORT_IMAGE_ZIP]: 'IMAGE ZIP',
		[T.EXPORT_DDS]: 'DISTRIBUTION DESIGN STUDIO (DDS) (BETA)',
		[T.EXPORT_SHAPEFILE]: 'SHAPEFILE',
		[T.EXPORT_SHAPEFILE_WGS84_TITLE]: 'Shapefile export uses WGS84',
		[T.EXPORT_SHAPEFILE_WGS84_BODY]: 'Shapefile export assumes all horizontal and vertical coordinates are in WGS84',
		[T.EXPORT_NOT_EVERYTHING_EXPORTED]: 'Not all collections could be exported because no locations were provided',
		[T.EXPORT_DEPRECATED]: 'This export is going to be removed. If you experience problems, please contact support.',
		[T.EXPORT_STARTED]: ({ type, name }) => `Export started: ${type} - ${name}`,

		[T.EXPORT_MANAGER_TITLE]: 'Exports',
		[T.EXPORT_MANAGER_EMPTY]: 'No exports',
		[T.EXPORT_MANAGER_CLEAR]: 'Clear',
		[T.EXPORT_MANAGER_CLEAR_CONFIRM]: 'Some exports have not been downloaded or reviewed. Clear anyway?',
		[T.EXPORT_MANAGER_NAVIGATE_AWAY]: 'Page navigation is not available while an export is in progress.',
		[T.EXPORT_MANAGER_NAVIGATE_TITLE]: 'Export in progress',
		[T.EXPORT_MANAGER_STATUS_READY]: 'Ready',
		[T.EXPORT_MANAGER_STATUS_DOWNLOADED]: 'Downloaded',
		[T.EXPORT_MANAGER_STATUS_WARNING]: 'Warning',
		[T.EXPORT_MANAGER_STATUS_ERROR]: 'Error',
		[T.EXPORT_MANAGER_STATUS_FAILED]: 'Failed',
		[T.EXPORT_FINISHED]: ({ type, issue }) => `${type} export has finished${issue ? ` with ${issue}` : ''}`,
		[T.EXPORT_FINISHED_WARNINGS]: 'warnings',
		[T.EXPORT_FINISHED_ERRORS]: 'errors',

		[T.FIELD_VECTOR_P2P_DISPLAY]: ({ length, angle }) => `${length} at ${angle}`,

		[T.FORM_TITLE]: 'Forms',
		[T.FORM_NAME]: 'Name',
		[T.FORM_DESCRIPTION]: 'Description',
		[T.FORM_VERSION]: 'Current version',
		[T.FORM_UPDATED_AT]: 'Last Modified',
		[T.FORM_CREATED_AT]: 'Created',
		[T.FORM_EDIT]: 'Edit Form',
		[T.FORM_EDIT_TITLE]: 'Form Information',
		[T.FORM_CREATE]: 'Create Form',
		[T.FORM_IMPORT]: 'Import Form',
		[T.FORM_IMPORT_POLEFOREMAN]: 'Create IKE PoleForeman Form',
		[T.FORM_IMPORT_POLEFOREMAN_ERROR_DATABASE]: 'Error fetching IPF databases. Please try again later.',
		[T.FORM_IMPORT_POLEFOREMAN_OK]: 'Submit',
		[T.FORM_IMPORT_POLEFOREMAN_FETCHING_ORGS]: 'Fetching organizations...',
		[T.FORM_IMPORT_POLEFOREMAN_SELECT_ORG]: 'Select an organization',
		[T.FORM_IMPORT_POLEFOREMAN_FETCHING_OP_CO]: 'Fetching operating companies.\nThis may take a few moments...',
		[T.FORM_IMPORT_POLEFOREMAN_ERROR_OP_CO]: 'Error loading operating companies. Please try again later.',
		[T.FORM_IMPORT_POLEFOREMAN_SINGLE_OP_CO]: (opCo: string) =>
			`Single operating company (${opCo}) found. Creating form...`,
		[T.FORM_IMPORT_POLEFOREMAN_SELECT_OP_CO]: 'Select an operating company',
		[T.FORM_IMPORT_POLEFOREMAN_DESCRIPTION]: "Pick an Organization's IKE PoleForeman database",
		[T.FORM_IMPORT_POLEFOREMAN_OP_CO_DESCRIPTION]:
			"Pick from one of the available Operating Companies within the selected organization's database",
		[T.FORM_IMPORT_POLEFOREMAN_NO_DATABASES]:
			'You do not have access to any IKE PoleForeman databases. Please check with your IKE Access administrator or ikeGPS staff to configure access.',
		[T.FORM_IMPORT_POLEFOREMAN_NO_OPERATING_COMPANIES]:
			'The selected database seems to be malformed and does not contain any operating companies. Please check with your IPF database administrator',
		[T.FORM_IMPORT_POLEFOREMAN_ERROR_CREATION]: 'Error creating IKE PoleForeman form. Please try again later.',
		[T.FORM_IMPORT_UPLOAD_BUTTON]: 'Click to upload',
		[T.FORM_IMPORT_CONFIRM]: 'Submit',
		[T.FORM_IMPORT_SUCCEED]: 'Form imported successfully!',
		[T.FORM_IMPORT_CHOOSE_FILE]: 'Choose a supported form file to import from',
		[T.FORM_IMPORT_VALIDATION_ERROR_TITLE]: 'Form import failed with errors',
		[T.FORM_IMPORT_VALIDATION_WARNING_TITLE]: 'Form import has warnings',
		[T.FORM_IMPORT_VALIDATION_CREATE_FORM]: 'Create Form',
		[T.FORM_IMPORT_VALIDATION_SECTION_ERRORS]: 'Errors',
		[T.FORM_IMPORT_VALIDATION_SECTION_WARNINGS]: 'Warnings',
		[T.FORM_IMPORT_VALIDATION_SECTION_INFO]: 'Info',
		[T.FORM_NEW_POLEFOREMAN_FORM]: 'New IKE PoleForeman Form',
		[T.FORM_NEW_COPY_CUSTOM_FIELDS_FROM]: 'Copy custom fields from: ',
		[T.FORM_PLA_SUPPORT]: 'PLA Support',
		[T.FORM_LIST_ADD]: 'Add item',
		[T.FORM_FIELD_DISPLAY_NAME]: 'Display name',
		[T.FORM_FIELD_ANNOTATION_LABEL_FIELD_ID]: 'Annotation Label Field Id',
		[T.FORM_FIELD_DESCRIPTION]: 'Description',
		[T.FORM_FIELD_TYPE]: 'Field type',
		[T.FORM_FIELD_ADD_HIDE]: 'Hide create field',
		[T.FORM_FIELD_MOVE_UP]: 'Move field up',
		[T.FORM_FIELD_MOVE_DOWN]: 'Move field down',
		[T.FORM_OPTION_CLONEABLE]: 'Cloneable',
		[T.FORM_OPTION_CLONEABLE_TITLE]: 'Clone to new collection in IKE Field',
		[T.FORM_OPTION_LABEL]: 'Label',
		[T.FORM_OPTION_LABEL_TITLE]: ({ isRoot }) => `Label for each ${isRoot ? 'form' : 'subform'}`,
		[T.FORM_OPTION_SECONDARY_LABEL]: 'Secondary label',
		[T.FORM_OPTION_HIDE]: 'Hide',
		[T.FORM_OPTION_HIDE_TITLE]: 'Hide on IKE Field',
		[T.FORM_OPTION_ADMIN_ONLY]: 'Admin-only',
		[T.FORM_OPTION_ADMIN_ONLY_TITLE]: 'Make editable by admin users only',
		[T.FORM_OPTION_STATUS]: 'Status',
		[T.FORM_OPTION_STATUS_TITLE]: 'Use this field as the status',
		[T.FORM_OPTION_MAP_COLOR]: 'Map Color',
		[T.FORM_OPTION_MAP_COLOR_TITLE]: 'Use this field to set collection map colors',
		[T.FORM_OPTION_REQUIRED]: 'Required',
		[T.FORM_OPTION_REQUIRED_TITLE]: 'This field is required',
		[T.FORM_OPTION_ADDRESS]: 'Address',
		[T.FORM_OPTION_ADDRESS_TITLE]: 'Make this field an address lookup',
		[T.FORM_OPTION_PRO_ONLY_TITLE]: 'Editing this field is an IKE Office Pro only feature',
		[T.FORM_OPTION_LOCKED]: 'Locked for Base Form support',
		[T.FORM_FIELD_CHOOSE]: 'Select a field to add',
		[T.FORM_FIELD_ADD]: ({ name }) => `Add field to ${name || 'form'}`,
		[T.FORM_FIELD_CREATE]: 'Create Field',
		[T.FORM_FIELD_CANNOT_CHANGE]: 'Populated fields cannot be changed',
		[T.FORM_FIELD_DELETE]: 'Delete field',
		[T.FORM_FIELD_DELETE_TITLE]: 'Delete field',
		[T.FORM_FIELD_DELETE_CONFIRM]: ({ name }) => `Are you sure you want to delete field ${name}?`,
		[T.FORM_FIELD_NESTED_LIST_DELETE]: 'Delete value',
		[T.FORM_FIELD_NESTED_LIST_DELETE_TITLE]: 'Delete value',
		[T.FORM_FIELD_NESTED_LIST_DELETE_CONFIRM]: 'Are you sure you want to delete this value and all children?',

		[T.FORM_DELETE]: 'Delete',
		[T.FORM_DELETE_TITLE]: 'Delete Form',
		[T.FORM_DELETE_CONFIRM]: ({ name }) => `Are you sure you would like to delete form: ${name}?`,
		[T.FORM_DELETE_SUCCESS]: ({ name }) => `Deleted ${name}`,
		[T.FORM_ARCHIVE]: 'Archive',
		[T.FORM_ARCHIVE_TITLE]: 'Archive Form',
		[T.FORM_ARCHIVE_CONFIRM]: ({ name }) =>
			`Are you sure you want to Archive ${name}? It will not be available in IKE Field. Archived forms can be restored at any time.`,
		[T.FORM_ARCHIVE_SUCCESS]: ({ name }) => `Archived ${name}`,
		[T.FORM_RESTORE]: 'Restore',
		[T.FORM_RESTORE_TITLE]: 'Restore Form',
		[T.FORM_RESTORE_CONFIRM]: ({ name }) => `Are you sure you would like to restore form: ${name}?`,
		[T.FORM_RESTORE_SUCCESS]: ({ name }) => `Restored ${name}`,
		[T.FORM_ARCHIVED_TITLE]: 'Archived Forms',

		[T.FORM_DUPLICATE]: 'Duplicate',
		[T.FORM_COPY_TO_DEPARTMENT]: 'Copy To Department',
		[T.FORM_SHARE]: 'Share To Department',
		[T.FORM_SHARE_TITLE]: 'Share Form',
		[T.FORM_SHARE_CONFIRM]: ({ name }) => `Share ${name}:`,
		[T.FORM_SHARE_SUCCESS]: ({ name }) => `Shared ${name}`,
		[T.FORM_COPY_TO_DEPARTMENT_TITLE]: () => 'Copy To Department',
		[T.FORM_COPY_TO_DEPARTMENT_CONFIRM]: ({ name }) => `Copy ${name}:`,
		[T.FORM_COPY_TO_DEPARTMENT_SUCCESS]: ({ name }) => `Copied ${name}`,
		[T.FORM_COPY_TO_DEPARTMENT_DESCRIPTION]: 'Duplicating the form will create a unique copy of the form.',
		[T.FORM_REFRESH]: 'Refresh Form',
		[T.FORM_REFRESH_MODAL_TITLE]: 'Form Refresh',
		[T.FORM_REFRESH_MODAL_TITLE_ERROR]: 'Form Refresh Error',
		[T.FORM_REFRESH_MODAL_ERROR]: ({ name }) => `An error occurred while refreshing ${name}:`,
		[T.FORM_REFRESH_SUCCESS]: ({ name }) => `Successfully Refreshed ${name}`,

		[T.FORM_NAME_MISSING]: 'Name missing',
		[T.FORM_DESCRIPTION_MISSING]: 'Description missing',
		[T.FORM_ERROR_SAVING]: 'Error saving form',
		[T.FORM_ERROR_DELETING]: 'Error deleting form',

		[T.FIELD_DISPLAY_NAME_MISSING]: 'Display Name is required',
		[T.FIELD_TEXT]: 'Text',
		[T.FIELD_HEIGHT]: 'Height',
		[T.FIELD_NUMBER]: 'Number',
		[T.FIELD_ORIENTATION]: 'Orientation',
		[T.FIELD_TRUE_SIZE]: 'Photo Measure',
		[T.FIELD_DATE]: 'Date',
		[T.FIELD_SELECT_LIST]: 'Select List',
		[T.FIELD_YES_NO]: 'Yes No',
		[T.FIELD_NESTED_LIST]: 'Nested List',
		[T.FIELD_NESTED_LIST_TITLE]: ({ level }) => `Level ${level} Title`,
		[T.FIELD_NESTED_LIST_VALUE]: 'Value',
		[T.FIELD_FORM]: 'Subform',
		[T.FIELD_LOCATION]: 'Location',
		[T.FIELD_LOCATION_ACCURACY]: 'Accuracy',
		[T.FIELD_LOCATION_ALT]: 'Altitude',
		[T.FIELD_LOCATION_ALT_IKE]: 'IKE Altitude',
		[T.FIELD_LOCATION_ALT_GROUND]: 'Ground Altitude',
		[T.FIELD_LOCATION_ANTENNA_HEIGHT]: 'Antenna Height',
		[T.FIELD_LOCATION_FIX]: 'GPS Fix',
		[T.FIELD_LOCATION_FIX_DGPS]: 'DGPS',
		[T.FIELD_LOCATION_FIX_GPS]: 'GPS',
		[T.FIELD_LOCATION_FIX_PPS]: 'PPS',
		[T.FIELD_LOCATION_FIX_RTKFIXED]: 'RTK Fix',
		[T.FIELD_LOCATION_FIX_RTKFLOAT]: 'RTK Float',
		[T.FIELD_LOCATION_MANUAL]: 'Manually imported location',
		[T.FIELD_LOCATION_EDITED]: 'Manually edited location',
		[T.FIELD_LOCATION_TRUESIZE]: 'Target location',
		[T.FIELD_LOCATION_GPS]: 'GPS location',
		[T.FIELD_PROVIDER]: 'Provider',
		[T.FIELD_IMAGE]: 'Image',
		[T.FIELD_VECTOR]: 'Vector',
		[T.FIELD_ANCHOR]: 'Anchor',

		[T.FIELD_VECTOR_PROVIDER_MANUAL]: 'Manual',
		[T.FIELD_VERTICAL_SEPARATION]: 'Vertical separation',
		[T.FIELD_VERTICAL_SEPARATION_CLEARANCE]: 'Clearance Threshold (optional)',
		[T.FIELD_FILE_TOOL]: 'File tool',
		[T.FIELD_FILE_TOOL_FILE_SIZE]: 'File size',

		[T.FORM_NOT_FOUND]: 'Form not found.',

		[T.LIST_MAP]: 'Map',
		[T.LIST_JOB_LIST]: 'Jobs',
		[T.LIST_FORM_LIST]: 'Forms',
		[T.LIST_USER_ACCOUNTS]: 'Accounts',
		[T.LIST_COLLECTION_IMPORT]: 'Import',

		[T.LOGIN]: 'Login',
		[T.LOGOUT]: 'Logout',
		[T.LOGIN_WITH_AUTH0]: 'Login with IKE ID',
		[T.LOGIN_NO_AUTH0_ACCOUNT]: "I don't have an IKE ID account",
		[T.UNABLE_TO_START_SSO_SERVICE]: 'Unable to start IKE ID Service',
		[T.LOGIN_OFFICE]: 'Login to IKE Office',

		[T.FILE_NOT_SUPPORTED]: 'File type not supported.',
		[T.FILE_TOO_LARGE]: ({ limit }) => `File is too large. Maximum size is ${limit}.`,
		[T.FILE_DELETE]: 'Delete',
		[T.FILE_DELETE_TITLE]: 'Delete Uploaded File',
		[T.FILE_DELETE_MESSAGE]: (file) => `Do you want to delete ${file}?`,

		[T.ME]: 'me',

		[T.MISSING_404_CODE]: '404',
		[T.MISSING_404_TITLE]: 'Page not found',
		[T.MISSING_404_BEFORE_LINK]: 'Please go back to the ',
		[T.MISSING_404_LINK]: 'homepage',
		[T.MISSING_404_AFTER_LINK]: ' and start from there',

		[T.MISSING_403_CODE]: '403',
		[T.MISSING_403_TITLE]: 'Missing Permissions',
		[T.MISSING_403_BEFORE_LINK]: 'Please go back to the ',
		[T.MISSING_403_LINK]: 'map',
		[T.MISSING_403_AFTER_LINK]: ' and start from there',

		[T.MISSING_PAGE_NA]: 'is not yet available',

		[T.MULTI_ORG_MAP]: 'Multi-Org Map',

		[T.NAVIGATE_MAP]: 'Go to map',

		[T.NO_LOCATION]: 'no location',
		[T.NO_CAPTURES]: 'No images collected',
		[T.SELECT_CAPTURE]: 'Select a capture to view',

		[T.NOTIFICATION_IN]: (fieldName) => `in ${fieldName}`,
		[T.NOTIFICATION_ERROR_TITLE]: 'Export failed with errors',
		[T.NOTIFICATION_WARNING_TITLE]: 'Export completed with warnings',
		[T.NOTIFICATION_CODE_REQUIRED]: 'is missing',
		[T.NOTIFICATION_CODE_DEFAULT]: 'was defaulted',
		[T.NOTIFICATION_CODE_INVALID]: 'is invalid',
		[T.NOTIFICATION_CODE_UNKNOWN]: 'is invalid',

		[T.NOTIFICATION_REASON_AGL]: 'AGL is higher than pole height.',
		[T.NOTIFICATION_REASON_NO_LOCATION]: 'No location.',
		[T.NOTIFICATION_REASON_NO_GUY_WIRE]: 'Missing guy wire.',
		[T.NOTIFICATION_REASON_CLIENT_ITEM]: (item) => `Missing ${item} from catalogue.`,
		[T.NOTIFICATION_REASON_OTHER]: (item) => item,
		[T.NOTIFICATION_REASON_ONLY]: (item) => item,
		[T.NOTIFICATION_REASON_MISSING]: (item) => item,
		[T.REASON_SHAPEFILE_VALUE_TRUNCATED]: ({ columnSize }: { columnSize: number }) =>
			`value was too long for the shapefile column (${columnSize} characters) and was truncated`,
		[T.REASON_PLA_COUNT_ON_SPAN_MISMATCH]: ({ selfCount, otherCount, type }) =>
			`Number of (${type}) on this span (${selfCount}) must equal the number of (${type}) on the connected span (${otherCount})`,
		[T.REASON_PLA_COLLECTION_LINK_ONE_WAY]: ({ poleCollectionTitle, targetCollectionTitle }) =>
			`The pole "${poleCollectionTitle}" needs to be collection linked to "${targetCollectionTitle}" to enable span connectivity`,
		[T.REASON_PLA_SPAN_SAME_TYPE_LINKED]: ({ linkedPole, type }: { linkedPole: string; type: IPFSpanType }) =>
			`Link to pole: ${linkedPole} uses spans of the same type: '${formatIpfSpanType(type)}'. One span should be changed to '${IPF_SPAN_TYPES.filter(
				(x) => x !== type
			)
				.map(formatIpfSpanType)
				.join("' or '")}'`,
		[T.REASON_IPF_SPAN_OTHER_TO_OTHER_LINKED]: ({ linkedPole }: { linkedPole: string }) =>
			`Span Type was defaulted - Span going to ${linkedPole} has two '${formatIpfSpanType(IPFSpanType.OTHER)}' spans linked together. Exporting as '${formatIpfSpanType(IPFSpanType.FORE_SPAN)}'.`,
		[T.REASON_PLA_MULTIPLE_SPANS_LINKED]: ({ poleCollectionTitle, targetCollectionTitle }) =>
			`Multiple Spans are linked between '${poleCollectionTitle ?? 'No title'}' and '${targetCollectionTitle ?? 'No title'}' when there can only be one. One of the spans will be used for this export`,
		[T.REASON_PLA_POWER_CIRCUIT_PHASE_HEIGHT_MISMATCH]: ({ phase, linkedPole, missingSideTitle, populatedSideTitle }) =>
			`${phase} height mismatch with connected Pole '${linkedPole}'. Value is set on Pole '${populatedSideTitle}' but is missing on Pole '${missingSideTitle}'.`,
		[T.REASON_PLA_POWER_CIRCUIT_GROUP_MISMATCH]: ({ group, populatedSideTitle, missingSideTitle }) =>
			`${group} conductor/framing data is set on Pole '${populatedSideTitle}' but missing on the connected Pole '${missingSideTitle}'. Both sides of the span must have matching conductor groups.`,
		[T.REASON_PLA_CIRCUIT_TYPE_MISMATCH]: ({ circuitCategory, linkedPole, thisType, otherType }) =>
			`${circuitCategory} type '${thisType}' does not match type '${otherType}' on connected Pole '${linkedPole}'.`,
		[T.REASON_IPF_ANCHOR_ASSEMBLY_TYPE_NOT_FOUND]: ({ displayDescription }) =>
			`Anchor Assembly Type "${displayDescription}" was not found in the IPF database.`,
		[T.REASON_IPF_ANCHOR_LEAD_LENGTH_MISSING]: 'Anchor Lead Length is missing. Defaulting to 0.',
		[T.REASON_IPF_ANCHOR_TOO_MANY_GUYS]: 'Anchor has too many guy wires. The maximum is 3',
		[T.REASON_IPF_CONDUCTOR_TYPE_NOT_FOUND]: ({ displayDescription, rulingSpan }) =>
			`Conductor Type "${displayDescription} -> ${rulingSpan}" was not found in the IPF database`,
		[T.REASON_IPF_CYCLE_DETECTED]:
			'Cycle Detected -- This pole creates a collection linked loop, which IKE PoleForeman does not support.',
		[T.REASON_IPF_ISOLATED_POLES_DETECTED]:
			'Isolated Poles Detected -- All collections need to be collection linked in order to enable span connectivity',
		[T.REASON_IPF_EQUIPMENT_ATTACHMENT_HEIGHT_MISSING]:
			'Equipment Attachment Height is missing. Defaulting to 0 meters.',
		[T.REASON_IPF_EQUIPMENT_ORIENTATION_MISSING]: 'Equipment Orientation is missing. Defaulting to 0 degrees.',
		[T.REASON_IPF_EQUIPMENT_TYPE_NOT_FOUND]: ({ equipmentType, displayDescription }) =>
			`Equipment Type "${equipmentType} -> ${displayDescription}" was not found in the IPF database.`,
		[T.REASON_IPF_FRAMING_TYPE_NOT_FOUND]: ({ displayDescription }) =>
			`Framing Type "${displayDescription}" was not found in the IPF database.`,
		[T.REASON_IPF_GUY_ATTACHMENT_HEIGHT_MISSING]: 'Guy Attachment Height is missing. Defaulting to 0',
		[T.REASON_IPF_GUY_TYPE_NOT_FOUND]: ({ displayDescription }) =>
			`Guy Size ${displayDescription} was not found in the IPF database.`,
		[T.REASON_IPF_GUY_INSULATOR_TYPE_NOT_FOUND]: 'Guy Insulator Type was not found in the IPF database.',
		[T.REASON_IPF_JOINT_USE_CABLE_TYPE_NOT_FOUND]: ({ displayDescription, rulingSpan }) =>
			`Joint Use Cable Type "${displayDescription} -> ${rulingSpan}" was not found in the IPF database.`,
		[T.REASON_IPF_MULTIPLE_SPANS_SAME_TYPE]: ({ poleCollectionTitle }) =>
			`The pole "${poleCollectionTitle}" has multiple linked spans of the same type. Only one type is allowed`,
		[T.REASON_IPF_POWER_CIRCUIT_TYPE_NOT_FOUND]: ({ displayDescription }) =>
			`Power Circuit Type ${displayDescription} was not found in the IPF database`,
		[T.REASON_IPF_SERVICE_CANNOT_BE_COLLECTION_LINKED]: 'Service can not be collection linked',
		[T.REASON_IPF_SERVICE_LENGTH_MISSING]: 'Service Length is missing',
		[T.REASON_IPF_SERVICE_ENDPOINT_MISSING]: 'Service Endpoint Height is missing, Defaulting to Height of Attachment.',
		[T.REASON_IPF_SERVICE_MULTIPLE_POWER_CIRCUITS]:
			'Multiple power subforms found in a single Service subform which is not supported',
		[T.REASON_IPF_SERVICE_MULTIPLE_TELEPHONE_CABLES]:
			'Multiple telephone cables found in a single Service subform which is not supported',
		[T.REASON_IPF_SERVICE_MULTIPLE_CATV_CABLES]:
			'Multiple CATV cables found in a single Service subform which is not supported',
		[T.REASON_IPF_REQUIRED_FIELD]: 'This field is required by IKE PoleForeman',
		[T.REASON_IPF_POWER_CIRCUIT_NEEDS_GROUP]:
			'At least one Conductor and Framing must be set for Primary, Neutral, Secondary, or Shield',
		[T.REASON_IPF_POWER_CIRCUIT_PRIMARY_PHASE_HEIGHT_MISSING]:
			'At least one of the Primary Phase Heights (A, B, or C) must be set',
		[T.REASON_IPF_POWER_CIRCUIT_SECONDARY_PHASE_HEIGHT_MISSING]:
			'At least one of the Secondary Phase Heights (A, B, or C) must be set',
		[T.REASON_IPF_LOCATION_FALLBACK_TO_PHOTO]:
			'The pole does not have a Location set, the elevation from the first captured IKE Photo will be used instead. Elevation can greatly impact PLA in IKE PoleForeman, so please make corrections as needed.',
		[T.REASON_IPF_ALTITUDE_ZERO]: `Altitude might be missing (value = 0) - This could impact consistency with surrounding poles in IKE PoleForeman`,
		[T.REASON_IPF_TARGET_COLLECTION_NOT_FOUND]: `Linked collection is not a part of the export. Creating a Stand-In pole instead`,
		[T.REASON_IPF_SECONDARY_MULTIPLEX_MORE_THAN_1_ATTACHMENT_HEIGHT]:
			'There can only be a single associated attachment height on a Secondary Multiplex conductor. Used first attachment height found.',
		[T.REASON_DDS_REQUIRED_FIELD]: 'This field is required by DDS',
		[T.REASON_DDS_RECOMMENDED_FIELD]: 'This field is recommended by DDS',
		[T.REASON_DDS_LOCATION_FALLBACK_TO_PHOTO]:
			'The pole does not have a Location set, the elevation from the first captured IKE Photo will be used instead.',
		[T.REASON_DDS_EQUIPMENT_TYPE_NOT_FOUND]: ({ equipmentType, displayDescription }) =>
			`Equipment Type "${equipmentType} -> ${displayDescription}" was not found in the DDS catalogue.`,
		[T.NUMBER_INVALID]: 'Number invalid',
		[T.ORIENTATION_INVALID]: 'Invalid entry, value must be 0-360°',
		[T.NUMBER_IMPRECISE]: ({ minimumInputPrecision }) =>
			`${minimumInputPrecision} decimals or higher precision required`,

		[T.ORG_SEARCH]: 'Organization Wide Search',

		[T.UNKNOWN]: 'Unknown',

		[T.PHOTOMEASURE_JOIN]: 'Measurement will be linked to opposing span',
		[T.PHOTOMEASURE_JOIN_START]: (title) => `Measurement will link to: ${title}`,
		[T.PHOTOMEASURE_LINK]: 'Cancel Measure',
		[T.PHOTOMEASURE_LINK_START]: 'Measure Height',
		[T.PHOTOMEASURE_DELETE_ALL_TITLE]: 'Delete all measurements',
		[T.PHOTOMEASURE_DELETE_ALL_TEXT]: 'Are you sure you want to delete all of the measurements from the image?',
		[T.PHOTOMEASURE_HIDE_IMAGE_TITLE]: 'Hide image',
		[T.PHOTOMEASURE_HIDE_IMAGE_TEXT]: 'Are you sure you want to hide the image?',
		[T.PHOTOMEASURE_UNHIDE_IMAGE_TITLE]: 'Unhide image',
		[T.PHOTOMEASURE_UNHIDE_IMAGE_TEXT]: 'Are you sure you want to unhide the image?',
		[T.VERTICAL_SEPARATION_TOP]: 'Top',
		[T.VERTICAL_SEPARATION_BOTTOM]: 'Bottom',
		[T.VERTICAL_SEPARATION_INVALID]: 'Select a bottom height for vertical separation measurement',

		[T.USER_MENU_FORM]: 'Form List',
		[T.USER_MENU_ACCOUNTS]: 'Accounts',
		[T.USER_MENU_SETTINGS]: 'User Settings',
		[T.USER_MENU_CHANGE_PASSWORD]: 'Change Password',
		[T.USER_MENU_LOGOUT]: 'Logout',

		[T.PASSWORD_CHANGE_PASSWORD]: 'Change Password',
		[T.PASSWORD_CHANGE_PASSWORD_DETAIL]:
			'Are you sure you would like to change your password? You will receive a reset email which will be valid for 24 hours.',
		[T.PASSWORD_FORGOT_TITLE]: 'Reset password',
		[T.PASSWORD_FORGOT_EMAIL]: 'Email',
		[T.PASSWORD_FORGOT_ACCEPT]: 'Send reset email',
		[T.PASSWORD_RESET_EMAIL_SENT]: 'You have been sent a password reset email and will now be logged out.',
		[T.PASSWORD_FORGOT_SUCCESS]: 'A reset password link has been sent to you via email.',

		[T.PLA_SPIDACALC]: 'SPIDAcalc',
		[T.PLA_OCALC]: 'O-Calc',
		[T.PLA_DDS]: 'DDS',
		[T.PLA_POLEFOREMAN]: 'Legacy PoleForeman',
		[T.PLA_IKE_POLEFOREMAN]: 'IKE PoleForeman',

		[T.SPAN_O_MATIC]: 'Span-o-matic',

		[T.PRINT]: 'Print',

		[T.REPORT_PRE_LOAD_TITLE]: 'Exportable Reports',
		[T.REPORT_PRE_LOAD_LOADING]: 'Loading Report...',
		[T.REPORT_PRE_LOAD_INVALID_LICENSE]: 'You do not have a valid license to perform this action',
		[T.REPORT_COLLECTION_PLACE]: ({ index, of }) => `${index} of ${of}`,
		[T.REPORT_COLLECTION_VECTOR]: ({ distance, bearing }) => `${distance} at ${bearing}`,
		[T.REPORT_COLLECTION_ANCHOR]: ({ distance, bearing }) => `${distance} at ${bearing}`,
		[T.REPORT_COLLECTION_LAT_LNG]: ({ lat, lng }) => `(lat: ${lat}, lng: ${lng})`,
		[T.REPORT_COLLECTION_LAT_LNG_ALT]: ({ lat, lng, alt }) => `(lat: ${lat}, lng: ${lng}, alt: ${alt})`,

		[T.ROLE_USER]: 'User',
		[T.ROLE_ADMIN]: 'Admin',
		[T.ROLE_EDITOR]: 'Editor',
		[T.ROLE_DOWNLOADER]: 'Downloader',
		[T.ROLE_VIEWER]: 'Viewer',
		[T.ROLE_DATA_ADMIN]: 'Data Admin',

		[T.SAVE]: 'Save',
		[T.CLEAR_UNLOCKED_FIELDS]: 'Clear Unlocked Fields',
		[T.CLEAR_ALL_FIELDS]: 'Clear All Fields',
		[T.CLEAR_FIELDS_HELP]: 'Need help with removing locked fields? Submit a ticket',

		[T.SELECT]: (value: string) => `Select ${value}`,
		[T.SELECT_OPTION]: 'Select an option',
		[T.SELECT_MEASUREMENT]: 'Select attachment point to zoom',

		[T.SETTINGS_DATE_FORMAT]: 'Date Format',
		[T.SETTINGS_TITLE]: 'Change settings',
		[T.SETTINGS_UNITS]: 'Measurement Units',
		[T.SETTINGS_DONE]: 'Done',
		[T.SETTINGS_SAVED]: 'Settings saved...',
		[T.SETTINGS_ERROR_SAVING]: 'Error saving settings.',

		[T.SIGNUP_EMAIL]: 'Email',
		[T.SUBMIT]: 'Submit',
		[T.BACK_TO_LOGIN]: 'Back to login',

		[T.SSO_MIGRATE_EMAIL_SENT]: `Success! We've sent instructions on how to set a password for your new IKE ID to your inbox.`,
		[T.SSO_MIGRATE_EMAIL_EXISTING]: `Success! You can now login with the button below.`,
		[T.SSO_MIGRATE_FAILED]: `We couldn't find an IKE Office account for this email address, or this account has already been upgraded. Please contact customer support if you continue to experience issues trying to upgrade to an IKE ID.`,
		[T.SSO_UPGRADE_ACCOUNT]: 'Upgrade your IKE Office account',

		[T.SELECT_LIST_TITLE]: 'Text',
		[T.SELECT_LIST_VALUE]: 'Value',
		[T.SELECT_LIST_VALUE_UNIQUE]: 'Value must be unique',

		[T.ANCHOR_ALIGNMENT_INLINE]: 'Inline',
		[T.ANCHOR_ALIGNMENT_BISECT]: 'Bisect',
		[T.ANCHOR_ALIGNMENT_OTHER]: 'Other',

		[T.ACCURATE_ANCHOR_RELATED_SPAN_TITLE]: (label) => `Related Span ${label}`,

		[T.SORT_ASCENDING]: 'Ascending',
		[T.SORT_DESCENDING]: 'Descending',
		[T.SORT_TITLE]: 'Sort collections',
		[T.SORT_FIELD_COLLECTED_AT]: 'Collected at',
		[T.SORT_FIELD_COLLECTED_BY]: 'Collected by',
		[T.SORT_FIELD_UPDATED_AT]: 'Last Modified',
		[T.SORT_FIELD_NAME]: 'Title',
		[T.SORT_FIELD_STATUS]: 'Status',
		[T.SORT_FIELD_ASSIGNED]: 'Assigned to',

		[T.SPAN]: 'Span',
		[T.SPAN_LINK_CANCEL]: 'Cancel Span Link',
		[T.SPAN_LINK]: 'Span Link',
		[T.SPAN_LINK_TITLE]: 'Copy from existing Span',
		[T.SPAN_LINK_SELECT_CONTENT]: 'Select an existing span',
		[T.SPAN_LINK_SUCCESS]: ({ toSpan, fromCollection }) => `Created ${toSpan} from ${fromCollection}`,
		[T.SPAN_LINK_NO_MATCH]: 'No existing spans found near by',
		[T.SPAN_LINK_VERSION_MISMATCH]: 'Form versions differ between poles. Creating one-way span link.',
		[T.SPAN_LINK_MODAL_TITLE]: 'Select Span Link',
		[T.SPAN_LINK_WARNING_TEXT]: 'Note: Selecting an existing span will overwrite its data',
		[T.SPAN_LINK_CREATE_NEW]: 'Create new span',
		[T.SPAN_LINK_SELECT_SPAN]: 'Select a span to preview',
		[T.SPAN_LINK_SELECT_SPAN_TITLE]: 'Select an existing span or create a new one',
		[T.SPAN_LINK_LEARN_MORE]: 'Learn more about how span linking works',
		[T.SPAN_LINK_NEW_SPAN_INFO]: 'A new span will be created and linked',
		[T.SPAN_LINK_CONFIRM]: 'Link Span',
		[T.SPAN_LINK_DUPLICATE_ERROR]: ({ existingSpan }) =>
			existingSpan
				? `A span link to this pole already exists in "${existingSpan}"`
				: 'A span link to this pole already exists',
		[T.SPAN_LINK_TWO_WAY_SUCCESS]: 'Two-way span link created successfully',
		[T.SPAN_LINK_ERROR]: 'Failed to create span link',
		[T.SPAN_LINK_TARGET_SAVE_ERROR]: 'Failed to save linked pole. Please retry.',
		[T.SPAN_UNLINK_CONFIRM_TITLE]: 'Unlink Span',
		[T.SPAN_UNLINK_CONFIRM_MESSAGE]: ({ targetTitle }) =>
			`This will also unlink the corresponding span on "${targetTitle}". Continue?`,
		[T.SPAN_UNLINK_CONFIRM_OK]: 'Unlink',
		[T.SPAN_UNLINK_BOTH_SIDES]: ({ targetTitle }) =>
			`Span will be unlinked on both sides. Save to apply changes to "${targetTitle}".`,
		[T.SPAN_VECTOR_FIELD]: 'Span Vector Field',
		[T.SPAN_TYPE_FIELD]: 'Span Type Field',
		[T.SPAN_ENVIRONMENT_FIELD]: 'Environment Field',
		[T.SPAN_MID_SPAN_IKE_PHOTO_FIELD]: 'Mid Span IKE Photo Field',

		[T.SUBFORM_REMOVE_TITLE]: ({ title }) => `Remove ${title}`,
		[T.SUBFORM_REMOVE_CONFIRM]: ({ title }) => `Are you sure you want to remove this ${title}?`,
		[T.SUBFORM_REMOVE_REMOVE]: 'Remove',

		[T.TOOL_BASE]: 'Please select the base',
		[T.TOOL_SELECT]: 'Select',
		[T.TOOL_HEIGHT]: 'Height Marker',
		[T.TOOL_WIDTH]: 'Width Marker',
		[T.TOOL_CABLE_MEASURE]: 'Cable Measure',
		[T.TOOL_CABLE_MEASURE_INCREASE]: 'Increase cable size',
		[T.TOOL_CABLE_MEASURE_DECREASE]: 'Decrease cable size',
		[T.TOOL_ZOOM_IN]: 'Zoom in',
		[T.TOOL_ZOOM_OUT]: 'Zoom out',
		[T.TOOL_ZOOM_RESET]: 'Reset zoom',
		[T.TOOL_CROP_SET]: 'Set print area',
		[T.TOOL_BRIGHTNESS_INCREASE]: 'Increase brightness',
		[T.TOOL_BRIGHTNESS_DECREASE]: 'Decrease brightness',
		[T.TOOL_BRIGHTNESS_RESET]: 'Reset brightness',
		[T.TOOL_LASER_TOGGLE]: 'Laser Target',
		[T.TOOL_INFO_TOGGLE]: 'Show Info',
		[T.TOOL_MEASUREMENTS_CLEAR]: 'Delete all',
		[T.TOOL_DATE_TOGGLE]: 'Capture date',
		[T.TOOL_BEARING_TOGGLE]: 'Capture bearing',
		[T.TOOL_INSIGHT_DETECTIONS_TOGGLE_MARKERS]: 'Show/hide IKE Insight generated annotations',
		[T.TOOL_INSIGHT_DETECTIONS_TOGGLE_MASKS]: 'Show/hide IKE Insight generated masks',
		[T.TOOL_INSIGHT_DETECTIONS_MARKERS_NONE]: 'No IKE Insight annotations available',
		[T.TOOL_INSIGHT_DETECTIONS_MASKS_NONE]: 'No IKE Insight masks available',
		[T.TOOL_ARRANGE_ANNOTATIONS]: 'Arrange annotations',

		[T.TOPO_TOOL_RELOCATE_POLE]: 'Adjust pole location',
		[T.TOPO_TOOL_CREATE_POLE]: 'Add new pole',
		[T.TOPO_TOOL_SNAP]: 'Universal snapping',
		[T.TOPO_TOOL_MEASURE]: 'Measure ruling span',
		[T.TOPO_SAVE_JOB]: 'Save full job',
		[T.TOPO_SUCCESS_SAVE_JOB]: ({ amount }) => `Saved ${amount} collections`,
		[T.TOPO_UNSAVED_COLLECTION]: 'unsaved',
		[T.TOPO_SHOW_HIDE_LABELS]: 'Show/hide labels ─ Ctrl + L',
		[T.TOPO_SHOW_CAROUSEL]: 'Show image carousel',
		[T.TOPO_SHOW_COLLECTION_DATA]: 'Show collection data',
		[T.TOPO_MUST_SAVE_FIRST]: 'Must save collection before linking',
		[T.TOPO_MUST_SAVE_TARGET_FIRST]: 'You must save that collection before linking',
		[T.MEASUREMENT_CLICK_TO_REMOVE]: 'Click to remove',

		[T.MAPMODE_LEGEND_DROPSPAN]: 'Drop span',
		[T.MAPMODE_LEGEND_ANCHOR]: 'Anchor',
		[T.MAPMODE_LEGEND_SPAN]: 'Span',
		[T.MAPMODE_LEGEND_UNKNOWN]: 'Unknown',
		[T.MAPMODE_LEGEND_COLLECTION_LABEL]: 'Collection Label',
		[T.MAPMODE_LEGEND_SELECTED_COLLECTION]: 'Selected Collection',
		[T.MAPMODE_LEGEND_LOCATION_RTK_FIXED]: 'Location RTK Fixed',
		[T.MAPMODE_LEGEND_LOCATION_REVIEWED]: 'Location Reviewed',
		[T.MAPMODE_LEGEND_LOCATION_RTK_FLOAT]: 'Location RTK Float / Manual',
		[T.MAPMODE_LEGEND_LOCATION_LOW_ACCURACY]: 'Location Lower Accuracy',

		[T.MEASUREMENT_EMPTY_STATE]: 'Click on the map to start measuring',
		[T.MEASUREMENT_PAUSE_TOOLTIP]: 'Pause adding points',
		[T.MEASUREMENT_RESUME_TOOLTIP]: 'Resume adding points',
		[T.MEASUREMENT_RULING_SPAN]: 'Ruling Span:',
		[T.MEASUREMENT_TOTAL_DISTANCE]: 'Total Distance:',

		[T.TOPO_TOOL_DISTANCE_MEASURE]: 'Measure between points',
		[T.DISTANCE_MEASURE_DISTANCE]: 'Distance:',
		[T.DISTANCE_MEASURE_BEARING]: 'Bearing:',
		[T.DISTANCE_MEASURE_EMPTY_STATE]: 'Click on the map to start measuring',

		[T.UNIT_SHORT_FEET]: 'ft',
		[T.UNIT_SHORT_INCH]: 'in',
		[T.UNIT_SHORT_METER]: 'm',
		[T.UNIT_SHORT_DEGREE]: 'deg',

		[T.UNIT_FEET_INCH]: 'Feet/Inches',
		[T.UNIT_METER]: 'Meters',

		[T.USER_ASSIGN_REQUIRED]: 'Choose a user',

		[T.YES]: 'Yes',
		[T.NO]: 'No',

		[T.LAT]: 'Latitude',
		[T.LNG]: 'Longitude',

		[T.ERROR]: 'error',
		[T.CREATED]: 'created',
		[T.UPDATED]: 'updated',
		[T.IMPORT_FAILED]: 'Import Failed',

		[T.FILTER]: 'Search list entries',

		[T.MESSAGE_MOBILE_VALIDATION_TITLE]: 'IKE Office on Mobile',
		[T.MESSAGE_MOBILE_VALIDATION_CONTENT]: 'IKE Office is not optimized for mobile use.',
		[T.MESSAGE_BROWSER_VALIDATION_TITLE]: 'IKE Office Browser Compatibility',
		[T.MESSAGE_BROWSER_VALIDATION_CONTENT]:
			'Your browser is not fully supported for use with IKE Office. For more information please see ',
		[T.MESSAGE_BROWSER_VALIDATION_URL]: 'https://ikegps.com/support/ike-office-supported-browsers/',
		[T.MESSAGE_BROWSER_VALIDATION_URL_TEXT]: 'Supported Browsers',

		[T.LICENSE_CHECK_FAILED_TEXT]:
			'You do not have a license to perform this action. Licenses are managed in IKE Access, learn about license management ',
		[T.LICENSE_CHECK_FAILED_LINK]: 'here',
		[T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_TEXT]: 'Need help contacting your license admin? Reach out to ',
		[T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL]: 'support@ikegps.com',

		[T.REASON_SPIDA_CALC_TITLE_INVALID]: ({ displayDescription }) => `Pole id is invalid due to ${displayDescription}`,

		[T.REASON_SPIDA_CALC_SPAN_LINKING_TARGET_POLE_NOT_FOUND]: 'The target pole is not found in the export',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_MISMATCH]:
			'Only "Fore Span" and "Back Span" linking is valid. This span and its contents will need to be manually linked in SPIDAcalc',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_WIRES_COUNT_MISMATCH]:
			'The wire count does not match its linked span wire count. This span and its contents will need to be manually linked in SPIDAcalc',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_WIRES_TOO_MANY]:
			'There are too many wire subforms with this attachment height. The maximum number is 2',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUYS_COUNT_MISMATCH]:
			'The span-guy count does not match its linked span span-guy count. This span and its contents will need to be manually linked in SPIDAcalc',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_USAGE_GROUP_MISMATCH]:
			'The wire usage group does not match its linked wire usage group. The parent span and its contents will need to be manually linked in SPIDAcalc',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_SIZE_MISMATCH]:
			'The wire size does not match its linked wire size. The parent span and its contents will need to be manually linked in SPIDAcalc',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_TENSION_GROUP_MISMATCH]:
			'The wire tension group does not match its linked wire tension group. The parent span and its contents will need to be manually linked in SPIDAcalc',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_OWNER_MISMATCH]:
			'The wire owner does not match its linked wire owner. The parent span and its contents will need to be manually linked in SPIDAcalc',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_USAGE_GROUP_MISMATCH]:
			'The span-guy usage group does not match its linked span-guy usage group. The parent span and its contents will need to be manually linked in SPIDAcalc',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_SIZE_MISMATCH]:
			'The span-guy size does not match its linked span-guy size. The parent span and its contents will need to be manually linked in SPIDAcalc',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_TENSION_GROUP_MISMATCH]:
			'The span-guy tension group does not match its span-guy tension group. The parent span and its contents will need to be manually linked in SPIDAcalc',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_OWNER_MISMATCH]:
			'The span-guy owner does not match its linked span-guy owner. The parent span and its contents will need to be manually linked in SPIDAcalc',

		[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_ATTACHMENT_HEIGHT_EXCEED_AGL]:
			'The span-guy attachment height exceeds the AGL',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_MID_SPAN_HEIGHT_EXCEED_AGL]:
			'The span-guy mid span height exceeds the AGL',
		[T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_HEIGHT_EXCEED_AGL]: 'The span-guy height exceeds the AGL',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_MULTIPLE_FORM_VERSIONS]: 'Collections contain multiple form versions',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_TOO_MANY_COLLECTIONS]: 'Cannot import more than 1000 collections at once',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_STRING]: 'Cell must contain text',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LATITUDE]: 'Cell must contain a positive or negative number',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LONGITUDE]:
			'Cell must contain a positive or negative number',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_NUMBER]: 'Cell must contain a number',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_BOOLEAN]: 'Cell must contain TRUE or FALSE',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_ANCHOR]: 'Cell must contain Bisect, Inline, or Other',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH]: 'Cell must contain a length',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH_IMPERIAL]:
			'Cell must contain a valid length in feet and inches (e.g. 5\' 11")',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_FORM_ID_MISMATCH]: 'Sheet is for importing a different Form',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_FORM_REVISION_MISMATCH]: 'Sheet is for a different revision of the Form',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_DATE_FORMAT]: 'Invalid date format, must be YYYY-MM-DD',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_OPTION_DOES_NOT_EXIST]: 'Option does not exist',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_USER_NOT_FOUND]: 'User not found',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_OR_CORRUPTED_FILE]:
			'File could not be read (invalid format or corrupted file)',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_IMPORT_FILE_NO_ROWS]: 'The imported file had no Collection rows',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_FORM_OR_REVISION]: 'Invalid form or form revision',
		[T.REASON_EXPORT_IMPORTABLE_EXCEL_IMPORT_EXCEPTION]: 'Import Exception',
		[T.HELP_MENU]: 'Help & Resources',
		[T.SUBMIT_SUPPORT_REQUEST]: 'Submit Support Request',
		[T.SUPPORT_PORTAL]: 'Support Portal',
		[T.RELEASE_NOTES]: 'Release Notes',
		[T.ALL_RELEASE_NOTES]: 'All Release Notes',
		[T.VERSION_LABEL]: 'Version',

		[T.REVISION_ID]: 'Revision ID',
		[T.MODIFIED_AT]: 'Modified At',
		[T.MODIFIED_BY]: 'Modified By',
		[T.MODIFICATIONS]: 'Modifications',
	},
};

function formatIpfSpanType(spanType: IPFSpanType): string {
	switch (spanType) {
		case IPFSpanType.FORE_SPAN:
			return 'Fore Span';
		case IPFSpanType.BACK_SPAN:
			return 'Back Span';
		case IPFSpanType.OTHER:
			return 'Other';
		default:
			const exhaustiveCheck: never = spanType;
			return exhaustiveCheck;
	}
}

export function Translate(translateKey: string, attrs?: any): string {
	var currentTranslations = TRANSLATIONS[CURRENT_LANG];
	if (currentTranslations == null) {
		return translateKey;
	}

	var translation = currentTranslations[translateKey];
	if (translation == null) {
		return translateKey;
	}

	if (typeof translation === 'string') {
		return translation;
	}

	if (typeof translation === 'function') {
		return translation(attrs != null ? attrs : {});
	}

	throw new Error('Non string translations are not supported yet!');
}
